export const customFieldBuilderDe = {
  builderSubtitle: 'Kategorien, Gültigkeit, Übersetzungen und Darstellung zentral verwalten.',
  area: 'Fachlicher Bereich',
  createGroup: 'Neue Kategorie',
  groupCreated: 'Kategorie angelegt.',
  groupUpdated: 'Kategorie gespeichert.',
  groupArchived: 'Kategorie archiviert.',
  groupCreateTitle: 'Kategorie anlegen',
  groupEditTitle: 'Kategorie bearbeiten',
  groupDialogDescription: 'Kategorien gruppieren Felder in der späteren Stammdatenansicht.',
  name: 'Name',
  icon: 'Icon-Schlüssel',
  color: 'Farbe',
  scope: 'Gültigkeitsbereiche',
  partnerRoles: 'Partnerrollen',
  partnerRolesHint: 'Ohne Auswahl gilt die Konfiguration für alle Partnerrollen.',
  roles: { CUSTOMER: 'Kunde', PROSPECT: 'Interessent', SUPPLIER: 'Lieferant' },
  layoutWidth: 'Kartenbreite',
  widthFull: 'Volle Breite',
  widthHalf: 'Halbe Breite',
  fieldLayout: 'Feldlayout',
  oneColumn: 'Einspaltig',
  twoColumns: 'Zweispaltig',
  active: 'Aktiv',
  defaultExpanded: 'Standardmäßig geöffnet',
  hideEmptyInDetail: 'Leere Werte in der Detailansicht ausblenden',
  readPermissions: 'Zusätzliche Leseberechtigungen',
  writePermissions: 'Zusätzliche Schreibberechtigungen',
  permissionsHint: 'Ohne Auswahl besteht keine zusätzliche Einschränkung.',
  helpText: 'Inline-Hilfe',
  translationRequired: 'Diese Übersetzung fehlt oder besteht nur aus Leerzeichen.',
  translationDuplicate: 'Diese Übersetzung ist innerhalb der Sprache doppelt vorhanden.',
  translationStatusComplete: 'Vollständig',
  translationStatusIncomplete: 'Unvollständig',
  translationValidationTitle: 'Das Zusatzfeld kann noch nicht gespeichert werden.',
  groupTranslationValidationTitle: 'Die Zusatzfeldkategorie kann noch nicht gespeichert werden.',
  translationValidationCount: 'Es fehlen oder widersprechen sich {{count}} Übersetzungen:',
  translationFields: {
    label: 'Bezeichnung',
    description: 'Beschreibung',
    helpText: 'Hilfetext',
    name: 'Kategoriebezeichnung',
  },
  translationFieldOption: 'Auswahloption „{{value}}“',
  errorTrackingId: 'Tracking-ID: {{trackingId}}',
  saveDraft: 'Entwurf speichern',
  checkAndActivate: 'Prüfen und aktivieren',
  draftSaved: 'Entwurf gespeichert.',
  activated: 'Zusatzfeld aktiviert.',
  draftStatus: 'Entwurf',
  pendingDraftStatus: 'Änderungsentwurf',
  translationCompleteness: '{{complete}} von {{total}} Sprachen vollständig',
  translationCompletenessHint:
    'Unvollständige Entwürfe können gespeichert, aber nicht aktiviert werden.',
  autoTranslationTitle: 'Kontrollierte automatische Übersetzung',
  autoTranslationPrivacy:
    'Nur sichtbare Definitionstexte werden an den lokalen Ollama-Dienst gesendet. Ergebnisse bleiben bis zur Übernahme ungespeichert.',
  translationSourceLanguage: 'Quellsprache',
  translateMissing: 'Fehlende Sprachen automatisch übersetzen',
  retranslateWarning:
    'Für alle Zielsprachen neue Vorschläge erzeugen? Bestehende Eingaben werden erst nach Ihrer ausdrücklichen Übernahme geändert.',
  retranslateAll: 'Alle neu übersetzen',
  cancelTranslation: 'Abbrechen',
  translationProgress: '{{completed}} von {{total}} Sprachen verarbeitet',
  retryTranslation: 'Erneut versuchen',
  translateLanguage: 'Übersetzen',
  translationReady: 'Vorschlag bereit',
  translationError: 'Fehlgeschlagen',
  translationRunning: 'Wird übersetzt',
  translationNotStarted: 'Noch nicht gestartet',
  translationSourceMissing:
    'Die Quellsprache und alle sichtbaren Quelloptionen müssen ausgefüllt sein.',
  autoTranslationFailed: 'Der lokale Übersetzungsdienst konnte diese Sprache nicht erzeugen.',
  translationCancelled: 'Die Übersetzung wurde abgebrochen. Sie können sie erneut starten.',
  translationReviewOnApply: 'Ihre ausdrückliche Übernahme bestätigt die fachliche Prüfung.',
  translationReviewPermissionMissing:
    'Sie können Vorschläge übernehmen und als Entwurf speichern; die Freigabe erfordert das Übersetzungsprüfrecht.',
  machineTranslation: 'Maschinell erzeugt',
  translationMemory: 'Aus geprüftem Übersetzungsspeicher',
  translationReviewed: 'Geprüft',
  translationReviewRequired: 'Prüfung erforderlich',
  translationReviewBlocksActivation:
    'Maschinelle Übersetzungen müssen vor der Aktivierung berechtigt geprüft werden.',
  translationComparisonTitle: 'Vergleich {{source}} → {{target}}',
  translationComparisonHint:
    'Vergleichen Sie Quelle, vorhandenen Text und Vorschlag vor der Übernahme.',
  discardSuggestion: 'Vorschlag verwerfen',
  applyChange: 'Änderung übernehmen',
  sourceText: 'Ausgangstext',
  existingTranslation: 'Vorhandene Übersetzung',
  suggestedTranslation: 'Vorgeschlagene Übersetzung',
  applyAllLanguageChanges: 'Alle Änderungen dieser Sprache übernehmen',
  unsavedWarning: 'Ungespeicherte Änderungen verwerfen?',
  confidentiality: 'Vertraulichkeitsstufe',
  confidentialities: { PUBLIC: 'Öffentlich', INTERNAL: 'Intern', CONFIDENTIAL: 'Vertraulich' },
  confidential: 'Vertraulich',
  optionTranslationsHint: 'Jeder Auswahlwert wird in allen ERP-Sprachen gepflegt.',
  optionValue: 'Technischer Wert',
  defaultAndValidation: 'Standardwert und Validierung',
  defaultValue: 'Standardwert',
  noDefault: 'Kein Standardwert',
  multiDefaultHint: 'Mehrere Werte mit Komma trennen.',
  minLength: 'Minimale Länge',
  maxLength: 'Maximale Länge',
  minimum: 'Minimalwert',
  maximum: 'Maximalwert',
  configurationLocked:
    'Für dieses Feld sind {{count}} Werte gespeichert. Schlüssel, Typ und bestehende Optionswerte sind geschützt.',
  impactAffectedRecords: 'Betroffene Datensätze',
  impactRisk: 'Änderungsrisiko',
  impactContexts: 'Entitäten und Rollen',
  impactUsageTitle: 'Verwendung der veröffentlichten Definition',
  impactNoUsage: 'Es wurden keine aktuellen Verwendungen gefunden.',
  impactUsages: {
    FORMS: 'Formulare',
    LISTS: 'Listen',
    FILTERS: 'Filter',
    FORMULAS: 'Formeln',
    PDF_TEMPLATES: 'PDF-Vorlagen',
    SPECIFICATIONS: 'Spezifikationen',
    IMPORT_PROFILES: 'Importprofile',
    DOCUMENTS: 'Belege und Belegpositionen',
    AUTOMATIONS: 'Automatisierungen und Segmente',
  },
  impactChangesTitle: 'Geprüfte Änderungen',
  impactChanges: {
    KEY: 'Technischer Schlüssel',
    FIELD_TYPE: 'Feldtyp',
    OPTIONS: 'Auswahlwerte oder deren Reihenfolge',
    FORMULA: 'Formel',
    SCOPE: 'Gültigkeitsbereich',
    REQUIRED: 'Pflichtfeldregel',
    DEFAULT: 'Standardwert',
    VISIBILITY: 'Darstellungs- und Sichtbarkeitsregeln',
    TRANSLATIONS: 'Übersetzungen',
  },
  impactRisks: { LOW: 'Niedrig', MEDIUM: 'Mittel', HIGH: 'Hoch' },
  impactMigrationTitle: 'Kontrollierte Umstellung erforderlich',
  impactMigrationHint:
    'Die veröffentlichte Definition bleibt bestehen. Führen Sie die Änderung über ein Ersatzfeld durch, damit historische Werte lesbar bleiben.',
  impactMigrationSteps: {
    CREATE_REPLACEMENT: 'Ersatzfeld mit der gewünschten Konfiguration anlegen',
    MAP_VALUES: 'Alte Werte explizit auf das Ersatzfeld abbilden',
    VERIFY_VALUES: 'Ergebnis und abhängige Konfigurationen prüfen',
    PUBLISH_REPLACEMENT: 'Geprüftes Ersatzfeld veröffentlichen',
    ARCHIVE_ORIGINAL: 'Bisheriges Feld archivieren',
  },
  impactConfirmTitle: 'Änderung prüfen und veröffentlichen',
  impactConfirmDescription:
    'Prüfen Sie Datensätze, Verwendungen und Risiko, bevor der Änderungsentwurf veröffentlicht wird.',
  impactPublish: 'Geprüfte Änderung veröffentlichen',
  impactAnalysisFailed:
    'Die Änderungsauswirkung konnte nicht geprüft werden. Es wurde nichts veröffentlicht.',
  impactAnalysisFailedWithTrackingId:
    'Die Änderungsauswirkung konnte nicht geprüft werden. Es wurde nichts veröffentlicht. Tracking-ID: {{trackingId}}',
  impactOptionLocked:
    'Diese Auswahloption besitzt gespeicherte Werte. Nutzen Sie für Änderungen den angezeigten Migrationsweg.',
  publicationReason: 'Begründung der Veröffentlichung',
  publicationReasonHint:
    'Die Begründung wird mit Benutzer und Zeitpunkt revisionssicher protokolliert.',
  defaultPublicationReason: 'Geprüfte Änderung über den Zusatzfeldeditor veröffentlicht.',
  versionHistoryTitle: 'Versionen und Veröffentlichung',
  versionHistoryHint:
    'Frühere Stände bleiben einsehbar; ein Rollback erzeugt immer einen neuen Entwurf.',
  revision: 'Revision {{revision}}',
  versionStatuses: {
    DRAFT: 'Entwurf',
    IN_REVIEW: 'Zur Prüfung',
    PUBLISHED: 'Veröffentlicht',
    SUPERSEDED: 'Früherer Stand',
  },
  versionReasonMissing: 'Keine gesonderte Begründung hinterlegt.',
  versionComparisonTitle: 'Vergleich mit der veröffentlichten Fassung',
  versionPublishedValue: 'Veröffentlicht',
  versionSelectedValue: 'Ausgewählt',
  versionIsPublished: 'Dies ist die aktuell veröffentlichte Fassung.',
  versionNoPublished:
    'Für dieses archivierte oder neue Feld gibt es derzeit keine aktive Veröffentlichung.',
  versionNoChanges: 'Keine fachlichen Unterschiede zur veröffentlichten Fassung.',
  versionFields: {
    translations: 'Übersetzungen',
    fieldType: 'Feldtyp',
    options: 'Auswahloptionen',
    formulaExpression: 'Formel',
    entityTypes: 'Entitäten',
    partnerRoles: 'Partnerrollen',
    isRequired: 'Pflichtfeld',
    defaultValue: 'Standardwert',
    showInList: 'Listendarstellung',
    isFilterable: 'Filter',
    showInPdf: 'PDF-Darstellung',
  },
  versionReason: 'Begründung',
  versionReasonHint: 'Mindestens drei Zeichen; wird im Audit-Nachweis gespeichert.',
  submitForReview: 'Zur Prüfung einreichen',
  rollbackAsDraft: 'Als neuen Entwurf wiederherstellen',
  inReviewStatus: 'Zur Prüfung',
  pendingReviewStatus: 'Änderung zur Prüfung',
  publishingSettingsTitle: 'Sichere Veröffentlichung',
  publishingSettingsHint: 'Steuern Sie die Freigabe von Zusatzfelddefinitionen mandantenweit.',
  fourEyesEnabled: 'Vier-Augen-Prinzip aktivieren',
  fourEyesDescription:
    'Der einreichende Benutzer darf dieselbe Revision nicht selbst veröffentlichen.',
  publishingSettingsSaved: 'Veröffentlichungseinstellung gespeichert.',
  transfer: {
    title: 'Export, Import und Massenpflege',
    description:
      'Definitionen und Übersetzungen exportieren, eine CSV-/XLSX-Datei vollständig prüfen und ausschließlich als Entwurf übernehmen.',
    exportXlsx: 'XLSX exportieren',
    exportCsv: 'CSV exportieren',
    selectFile: 'Importdatei auswählen',
    uploading: 'Datei wird geprüft …',
    previewHint:
      'Ein Import wird erst nach einer serverseitigen Vorschau und Ihrer Bestätigung ausgeführt.',
    previewTitle: 'Importvorschau',
    resultTitle: 'Importergebnis',
    errorReport: 'Fehlerbericht herunterladen',
    counts: {
      total: 'Gesamt',
      new: 'Neu',
      changed: 'Geändert',
      unchanged: 'Unverändert',
      invalid: 'Fehlerhaft',
    },
    errorSummary: '{{count}} Importfehler müssen behoben werden.',
    errorLine: 'Zeile {{row}}, Spalte {{column}}: {{message}}',
    row: 'Zeile',
    key: 'Feldschlüssel',
    area: 'Bereich',
    label: 'Bezeichnung',
    status: 'Ergebnis',
    statuses: { NEW: 'Neu', CHANGED: 'Geändert', UNCHANGED: 'Unverändert', INVALID: 'Fehlerhaft' },
    confirmDraftImport:
      'Ich habe die Vorschau geprüft und übernehme neue oder geänderte Definitionen als Entwurf.',
    generateMissing:
      'Fehlende Übersetzungen nach der Übernahme kontrolliert im Hintergrund erzeugen',
    sourceLocale: 'Ausgangssprache',
    draftOnly:
      'Der Import aktiviert keine Definition und überschreibt keine veröffentlichte Fassung.',
    importing: 'Import wird ausgeführt …',
    execute: 'Geprüften Import ausführen',
    completed:
      '{{created}} neue und {{changed}} geänderte Entwürfe übernommen; {{invalid}} Zeilen fehlgeschlagen.',
    translationJob: 'Übersetzungsauftrag',
    translationProgress: 'Fortschritt der automatischen Übersetzung',
    translationCounts: '{{done}} von {{total}} verarbeitet, {{failed}} fehlgeschlagen',
    retry: 'Auftrag fortsetzen',
  },
  quality: {
    title: 'Konfigurationsqualität',
    description:
      'Offene Übersetzungs-, Formel-, Nutzungs- und Auftragsprobleme erkennen und direkt bearbeiten.',
    refresh: 'Neu prüfen',
    category: 'Kategorie',
    language: 'Sprache',
    status: 'Status',
    metrics: {
      activeDefinitions: 'Aktive Zusatzfelder',
      incompleteDrafts: 'Unvollständige Entwürfe',
      missingTranslations: 'Fehlende Übersetzungen',
      unreviewedMachineTranslations: 'Ungeprüfte Maschinenübersetzungen',
      invalidFormulas: 'Ungültige Formeln',
      unusedDefinitions: 'Nicht verwendete Felder',
      archiveCandidates: 'Archivierungskandidaten',
      definitionConflicts: 'Definitionskonflikte',
      failedTranslationJobs: 'Fehlgeschlagene Übersetzungsaufträge',
    },
    byLanguage: 'Vollständigkeit je Sprache',
    languageProgress: 'Übersetzungsfortschritt für {{language}}',
    languageSummary: '{{complete}} von {{total}} vollständig · {{missing}} Texte fehlen',
    issues: 'Handlungsbedarf',
    noIssues: 'Für die gewählten Filter besteht kein Handlungsbedarf.',
    translationJob: 'Übersetzungsauftrag',
    issueKinds: {
      MISSING_TRANSLATION: '{{count}} Übersetzungen fehlen',
      UNREVIEWED_MACHINE_TRANSLATION: '{{count}} Maschinenübersetzungen ungeprüft',
      INVALID_FORMULA: 'Formel ungültig',
      UNUSED_DEFINITION: 'Nicht verwendet',
      ARCHIVE_CANDIDATE: 'Seit mindestens 180 Tagen ungenutzt',
      DEFINITION_CONFLICT: '{{count}} Definitionskonflikte',
      FAILED_TRANSLATION_JOB: '{{count}} Übersetzungen fehlgeschlagen',
    },
    trackingId: 'Tracking-ID: {{trackingId}}',
    open: 'Öffnen',
    generatedAt: 'Zuletzt geprüft: {{date}}',
  },
  showArchived: 'Archivierte anzeigen',
  showPreview: 'Vorschau anzeigen',
  noGroups: 'Noch keine Kategorie für diesen Bereich',
  noGroupsHint: 'Legen Sie zuerst eine Kategorie an und ordnen Sie ihr anschließend Felder zu.',
  dragGroup: 'Kategorie verschieben',
  dragField: 'Feld verschieben',
  dropFieldHere: 'Feld hierher ziehen oder ein neues Feld anlegen.',
  archivedStatus: 'Archiviert',
  fieldCount: '{{count}} Felder',
  valueCount: '{{count}} Werte',
  masterDataPreview: 'Stammdaten-Vorschau',
  masterDataPreviewHint: 'Darstellung mit der gewählten Kartenbreite und Feldanordnung.',
  usagePreviewContext: 'Nutzungskontext',
  usagePreviewLanguage: 'Vorschau-Sprache',
  usagePreviewViewport: 'Ansicht',
  usagePreviewViewports: { DESKTOP: 'Desktop', TABLET: 'Tablet', MOBILE: 'Mobil' },
  usagePreviewCanvas: 'Lokalisierte Nutzungsvorschau',
  usagePreviewSafeSample: 'Vorschau ohne Geschäftsdaten',
  usagePreviewMissingCategory: 'Kategorie fehlt',
  usagePreviewNoWarnings: 'Für diesen Kontext wurden keine Vorschauwarnungen erkannt.',
  usagePreviewWarnings: '{{count}} Vorschauwarnungen',
  usagePreviewWarningDetails: {
    label: 'Bezeichnung',
    category: 'Kategoriebezeichnung',
    options: 'Auswahloptionen',
  },
  usagePreviewWarning: {
    MISSING_TRANSLATION: 'In dieser Sprache fehlt ein sichtbarer Text ({{detail}}).',
    LABEL_TOO_LONG: 'Die Bezeichnung ist mit {{detail}} Zeichen möglicherweise zu lang.',
    DUPLICATE_LABEL: 'Ein anderes Feld verwendet in diesem Bereich dieselbe Bezeichnung.',
    INVALID_DEFAULT: 'Der Standardwert passt nicht zum Feldtyp oder zu den Auswahloptionen.',
    EMPTY_OPTION: 'Mindestens eine sichtbare Auswahloption ist leer oder fehlt.',
    VISIBILITY_CONFLICT: 'Gültigkeits- und Darstellungsregeln widersprechen sich.',
    INVALID_FORMULA: 'Die Formel kann nicht ausgewertet werden.',
  },
  emptyGroup: 'Diese Kategorie enthält noch keine Felder.',
  groupArchiveTitle: 'Kategorie archivieren',
  archiveImpactDescription:
    'Das Feld „{{label}}“ wird für neue Eingaben ausgeblendet. {{valueCount}} gespeicherte Werte bleiben lesbar.',
  groupArchiveDescription:
    'Die Kategorie „{{label}}“ und ihre {{fieldCount}} Felder werden für neue Eingaben ausgeblendet.',
  archivePreservesHistory:
    'Historische Werte, Beleg-Snapshots, Exporte und Audit-Einträge werden nicht gelöscht.',
  archiveImpact: 'Betroffen: {{fieldCount}} Felder und {{valueCount}} gespeicherte Werte.',
} as const;

export const customFieldBuilderEn = {
  builderSubtitle: 'Manage categories, scopes, translations and presentation in one place.',
  area: 'Business area',
  createGroup: 'New category',
  groupCreated: 'Category created.',
  groupUpdated: 'Category saved.',
  groupArchived: 'Category archived.',
  groupCreateTitle: 'Create category',
  groupEditTitle: 'Edit category',
  groupDialogDescription: 'Categories group fields in the future master-data view.',
  name: 'Name',
  icon: 'Icon key',
  color: 'Colour',
  scope: 'Scopes',
  partnerRoles: 'Partner roles',
  partnerRolesHint: 'Without a selection the configuration applies to all partner roles.',
  roles: { CUSTOMER: 'Customer', PROSPECT: 'Prospect', SUPPLIER: 'Supplier' },
  layoutWidth: 'Card width',
  widthFull: 'Full width',
  widthHalf: 'Half width',
  fieldLayout: 'Field layout',
  oneColumn: 'One column',
  twoColumns: 'Two columns',
  active: 'Active',
  defaultExpanded: 'Expanded by default',
  hideEmptyInDetail: 'Hide empty values in detail view',
  readPermissions: 'Additional read permissions',
  writePermissions: 'Additional write permissions',
  permissionsHint: 'No selection means no additional restriction.',
  helpText: 'Inline help',
  translationRequired: 'This translation is missing or contains only whitespace.',
  translationDuplicate: 'This translation is duplicated within the language.',
  translationStatusComplete: 'Complete',
  translationStatusIncomplete: 'Incomplete',
  translationValidationTitle: 'The custom field cannot be saved yet.',
  groupTranslationValidationTitle: 'The custom-field category cannot be saved yet.',
  translationValidationCount: '{{count}} translations are missing or conflicting:',
  translationFields: {
    label: 'Label',
    description: 'Description',
    helpText: 'Help text',
    name: 'Category label',
  },
  translationFieldOption: 'Option “{{value}}”',
  errorTrackingId: 'Tracking ID: {{trackingId}}',
  saveDraft: 'Save draft',
  checkAndActivate: 'Check and activate',
  draftSaved: 'Draft saved.',
  activated: 'Custom field activated.',
  draftStatus: 'Draft',
  pendingDraftStatus: 'Change draft',
  translationCompleteness: '{{complete}} of {{total}} languages complete',
  translationCompletenessHint: 'Incomplete drafts can be saved but cannot be activated.',
  autoTranslationTitle: 'Controlled automatic translation',
  autoTranslationPrivacy:
    'Only visible definition text is sent to the local Ollama service. Results remain unsaved until you apply them.',
  translationSourceLanguage: 'Source language',
  translateMissing: 'Automatically translate missing languages',
  retranslateWarning:
    'Generate new suggestions for every target language? Existing entries change only after you explicitly apply a suggestion.',
  retranslateAll: 'Translate all again',
  cancelTranslation: 'Cancel',
  translationProgress: '{{completed}} of {{total}} languages processed',
  retryTranslation: 'Try again',
  translateLanguage: 'Translate',
  translationReady: 'Suggestion ready',
  translationError: 'Failed',
  translationRunning: 'Translating',
  translationNotStarted: 'Not started',
  translationSourceMissing: 'The source language and every visible source option must be complete.',
  autoTranslationFailed: 'The local translation service could not generate this language.',
  translationCancelled: 'Translation was cancelled. You can retry it.',
  translationReviewOnApply: 'Explicitly applying a suggestion confirms your specialist review.',
  translationReviewPermissionMissing:
    'You may apply suggestions and save a draft; publishing requires translation review permission.',
  machineTranslation: 'Machine generated',
  translationMemory: 'From reviewed translation memory',
  translationReviewed: 'Reviewed',
  translationReviewRequired: 'Review required',
  translationReviewBlocksActivation:
    'Machine translations require an authorised review before activation.',
  translationComparisonTitle: 'Compare {{source}} → {{target}}',
  translationComparisonHint: 'Compare the source, existing text and suggestion before applying it.',
  discardSuggestion: 'Discard suggestion',
  applyChange: 'Apply change',
  sourceText: 'Source text',
  existingTranslation: 'Existing translation',
  suggestedTranslation: 'Suggested translation',
  applyAllLanguageChanges: 'Apply all changes for this language',
  unsavedWarning: 'Discard unsaved changes?',
  confidentiality: 'Confidentiality',
  confidentialities: { PUBLIC: 'Public', INTERNAL: 'Internal', CONFIDENTIAL: 'Confidential' },
  confidential: 'Confidential',
  optionTranslationsHint: 'Maintain every option in all ERP languages.',
  optionValue: 'Technical value',
  defaultAndValidation: 'Default and validation',
  defaultValue: 'Default value',
  noDefault: 'No default',
  multiDefaultHint: 'Separate multiple values with commas.',
  minLength: 'Minimum length',
  maxLength: 'Maximum length',
  minimum: 'Minimum',
  maximum: 'Maximum',
  configurationLocked:
    '{{count}} values use this field. Its key, type and existing option values are protected.',
  impactAffectedRecords: 'Affected records',
  impactRisk: 'Change risk',
  impactContexts: 'Entities and roles',
  impactUsageTitle: 'Published-definition usage',
  impactNoUsage: 'No current usage was found.',
  impactUsages: {
    FORMS: 'Forms',
    LISTS: 'Lists',
    FILTERS: 'Filters',
    FORMULAS: 'Formulas',
    PDF_TEMPLATES: 'PDF templates',
    SPECIFICATIONS: 'Specifications',
    IMPORT_PROFILES: 'Import profiles',
    DOCUMENTS: 'Documents and line items',
    AUTOMATIONS: 'Automations and segments',
  },
  impactChangesTitle: 'Checked changes',
  impactChanges: {
    KEY: 'Technical key',
    FIELD_TYPE: 'Field type',
    OPTIONS: 'Option values or their order',
    FORMULA: 'Formula',
    SCOPE: 'Scope',
    REQUIRED: 'Required-field rule',
    DEFAULT: 'Default value',
    VISIBILITY: 'Display and visibility rules',
    TRANSLATIONS: 'Translations',
  },
  impactRisks: { LOW: 'Low', MEDIUM: 'Medium', HIGH: 'High' },
  impactMigrationTitle: 'Controlled migration required',
  impactMigrationHint:
    'The published definition remains in place. Make this change through a replacement field so historical values stay readable.',
  impactMigrationSteps: {
    CREATE_REPLACEMENT: 'Create a replacement field with the intended configuration',
    MAP_VALUES: 'Explicitly map old values to the replacement field',
    VERIFY_VALUES: 'Verify the result and dependent configurations',
    PUBLISH_REPLACEMENT: 'Publish the reviewed replacement field',
    ARCHIVE_ORIGINAL: 'Archive the previous field',
  },
  impactConfirmTitle: 'Review and publish change',
  impactConfirmDescription: 'Review records, usage and risk before publishing the change draft.',
  impactPublish: 'Publish reviewed change',
  impactAnalysisFailed: 'The change impact could not be checked. Nothing was published.',
  impactAnalysisFailedWithTrackingId:
    'The change impact could not be checked. Nothing was published. Tracking ID: {{trackingId}}',
  impactOptionLocked:
    'This option has stored values. Use the displayed migration path to change it.',
  publicationReason: 'Publication reason',
  publicationReasonHint: 'The reason is recorded with user and time in the audit trail.',
  defaultPublicationReason: 'Reviewed change published through the custom-field editor.',
  versionHistoryTitle: 'Versions and publication',
  versionHistoryHint: 'Earlier states remain visible; rollback always creates a new draft.',
  revision: 'Revision {{revision}}',
  versionStatuses: {
    DRAFT: 'Draft',
    IN_REVIEW: 'In review',
    PUBLISHED: 'Published',
    SUPERSEDED: 'Earlier state',
  },
  versionReasonMissing: 'No separate reason was recorded.',
  versionComparisonTitle: 'Comparison with the published version',
  versionPublishedValue: 'Published',
  versionSelectedValue: 'Selected',
  versionIsPublished: 'This is the currently published version.',
  versionNoPublished: 'This archived or new field currently has no active published version.',
  versionNoChanges: 'No functional differences from the published version.',
  versionFields: {
    translations: 'Translations',
    fieldType: 'Field type',
    options: 'Options',
    formulaExpression: 'Formula',
    entityTypes: 'Entities',
    partnerRoles: 'Partner roles',
    isRequired: 'Required field',
    defaultValue: 'Default value',
    showInList: 'List display',
    isFilterable: 'Filter',
    showInPdf: 'PDF display',
  },
  versionReason: 'Reason',
  versionReasonHint: 'At least three characters; stored in the audit trail.',
  submitForReview: 'Submit for review',
  rollbackAsDraft: 'Restore as new draft',
  inReviewStatus: 'In review',
  pendingReviewStatus: 'Change in review',
  publishingSettingsTitle: 'Safe publication',
  publishingSettingsHint: 'Control custom-field publication for this tenant.',
  fourEyesEnabled: 'Enable four-eyes review',
  fourEyesDescription: 'The user who submits a revision cannot publish that same revision.',
  publishingSettingsSaved: 'Publication setting saved.',
  transfer: {
    title: 'Export, import and bulk maintenance',
    description:
      'Export definitions and translations, validate a CSV/XLSX file completely, and import it as drafts only.',
    exportXlsx: 'Export XLSX',
    exportCsv: 'Export CSV',
    selectFile: 'Select import file',
    uploading: 'Validating file …',
    previewHint: 'An import runs only after a server-side preview and your confirmation.',
    previewTitle: 'Import preview',
    resultTitle: 'Import result',
    errorReport: 'Download error report',
    counts: {
      total: 'Total',
      new: 'New',
      changed: 'Changed',
      unchanged: 'Unchanged',
      invalid: 'Invalid',
    },
    errorSummary: '{{count}} import errors must be corrected.',
    errorLine: 'Row {{row}}, column {{column}}: {{message}}',
    row: 'Row',
    key: 'Field key',
    area: 'Area',
    label: 'Label',
    status: 'Result',
    statuses: { NEW: 'New', CHANGED: 'Changed', UNCHANGED: 'Unchanged', INVALID: 'Invalid' },
    confirmDraftImport: 'I reviewed the preview and import new or changed definitions as drafts.',
    generateMissing: 'Generate missing translations in a controlled background job after import',
    sourceLocale: 'Source language',
    draftOnly: 'The import never activates a definition or overwrites its published version.',
    importing: 'Running import …',
    execute: 'Run reviewed import',
    completed: '{{created}} new and {{changed}} changed drafts imported; {{invalid}} rows failed.',
    translationJob: 'Translation job',
    translationProgress: 'Automatic translation progress',
    translationCounts: '{{done}} of {{total}} processed, {{failed}} failed',
    retry: 'Resume job',
  },
  quality: {
    title: 'Configuration quality',
    description:
      'Find outstanding translation, formula, usage and job issues and open them directly.',
    refresh: 'Check again',
    category: 'Category',
    language: 'Language',
    status: 'Status',
    metrics: {
      activeDefinitions: 'Active custom fields',
      incompleteDrafts: 'Incomplete drafts',
      missingTranslations: 'Missing translations',
      unreviewedMachineTranslations: 'Unreviewed machine translations',
      invalidFormulas: 'Invalid formulas',
      unusedDefinitions: 'Unused fields',
      archiveCandidates: 'Archive candidates',
      definitionConflicts: 'Definition conflicts',
      failedTranslationJobs: 'Failed translation jobs',
    },
    byLanguage: 'Completeness by language',
    languageProgress: 'Translation progress for {{language}}',
    languageSummary: '{{complete}} of {{total}} complete · {{missing}} texts missing',
    issues: 'Action required',
    noIssues: 'No action is required for the selected filters.',
    translationJob: 'Translation job',
    issueKinds: {
      MISSING_TRANSLATION: '{{count}} translations missing',
      UNREVIEWED_MACHINE_TRANSLATION: '{{count}} machine translations unreviewed',
      INVALID_FORMULA: 'Invalid formula',
      UNUSED_DEFINITION: 'Unused',
      ARCHIVE_CANDIDATE: 'Unused for at least 180 days',
      DEFINITION_CONFLICT: '{{count}} definition conflicts',
      FAILED_TRANSLATION_JOB: '{{count}} translations failed',
    },
    trackingId: 'Tracking ID: {{trackingId}}',
    open: 'Open',
    generatedAt: 'Last checked: {{date}}',
  },
  showArchived: 'Show archived',
  showPreview: 'Show preview',
  noGroups: 'No category for this area yet',
  noGroupsHint: 'Create a category first, then assign fields to it.',
  dragGroup: 'Move category',
  dragField: 'Move field',
  dropFieldHere: 'Drag a field here or create a new field.',
  archivedStatus: 'Archived',
  fieldCount: '{{count}} fields',
  valueCount: '{{count}} values',
  masterDataPreview: 'Master-data preview',
  masterDataPreviewHint: 'Presentation using the selected card width and field layout.',
  usagePreviewContext: 'Usage context',
  usagePreviewLanguage: 'Preview language',
  usagePreviewViewport: 'View',
  usagePreviewViewports: { DESKTOP: 'Desktop', TABLET: 'Tablet', MOBILE: 'Mobile' },
  usagePreviewCanvas: 'Localized usage preview',
  usagePreviewSafeSample: 'Preview without business data',
  usagePreviewMissingCategory: 'Category missing',
  usagePreviewNoWarnings: 'No preview warnings were found for this context.',
  usagePreviewWarnings: '{{count}} preview warnings',
  usagePreviewWarningDetails: { label: 'label', category: 'category name', options: 'options' },
  usagePreviewWarning: {
    MISSING_TRANSLATION: 'Visible text is missing in this language ({{detail}}).',
    LABEL_TOO_LONG: 'The label may be too long at {{detail}} characters.',
    DUPLICATE_LABEL: 'Another field uses the same label in this area.',
    INVALID_DEFAULT: 'The default value does not match the field type or options.',
    EMPTY_OPTION: 'At least one visible option is empty or missing.',
    VISIBILITY_CONFLICT: 'Scope and display rules conflict.',
    INVALID_FORMULA: 'The formula cannot be evaluated.',
  },
  emptyGroup: 'This category has no fields yet.',
  groupArchiveTitle: 'Archive category',
  archiveImpactDescription:
    'The field “{{label}}” is hidden for new input. {{valueCount}} stored values remain readable.',
  groupArchiveDescription:
    'The category “{{label}}” and its {{fieldCount}} fields are hidden for new input.',
  archivePreservesHistory:
    'Historic values, document snapshots, exports and audit entries are not deleted.',
  archiveImpact: 'Affected: {{fieldCount}} fields and {{valueCount}} stored values.',
} as const;

export const customFieldBuilderFr = {
  builderSubtitle: 'Gérez les catégories, portées, traductions et la présentation au même endroit.',
  area: 'Domaine fonctionnel',
  createGroup: 'Nouvelle catégorie',
  groupCreated: 'Catégorie créée.',
  groupUpdated: 'Catégorie enregistrée.',
  groupArchived: 'Catégorie archivée.',
  groupCreateTitle: 'Créer une catégorie',
  groupEditTitle: 'Modifier la catégorie',
  groupDialogDescription: 'Les catégories regroupent les champs dans la vue des données de base.',
  name: 'Nom',
  icon: 'Clé d’icône',
  color: 'Couleur',
  scope: 'Périmètres',
  partnerRoles: 'Rôles du partenaire',
  partnerRolesHint: 'Sans sélection, la configuration vaut pour tous les rôles.',
  roles: { CUSTOMER: 'Client', PROSPECT: 'Prospect', SUPPLIER: 'Fournisseur' },
  layoutWidth: 'Largeur de carte',
  widthFull: 'Pleine largeur',
  widthHalf: 'Demi-largeur',
  fieldLayout: 'Disposition des champs',
  oneColumn: 'Une colonne',
  twoColumns: 'Deux colonnes',
  active: 'Actif',
  defaultExpanded: 'Ouvert par défaut',
  hideEmptyInDetail: 'Masquer les valeurs vides en détail',
  readPermissions: 'Droits de lecture supplémentaires',
  writePermissions: 'Droits d’écriture supplémentaires',
  permissionsHint: 'Sans sélection, aucune restriction supplémentaire.',
  helpText: 'Aide contextuelle',
  translationRequired: 'Cette traduction est manquante ou ne contient que des espaces.',
  translationDuplicate: 'Cette traduction est en double dans cette langue.',
  translationStatusComplete: 'Complet',
  translationStatusIncomplete: 'Incomplet',
  translationValidationTitle: 'Le champ personnalisé ne peut pas encore être enregistré.',
  groupTranslationValidationTitle:
    'La catégorie de champs personnalisés ne peut pas encore être enregistrée.',
  translationValidationCount: '{{count}} traductions sont manquantes ou en conflit :',
  translationFields: {
    label: 'Libellé',
    description: 'Description',
    helpText: "Texte d'aide",
    name: 'Libellé de la catégorie',
  },
  translationFieldOption: 'Option « {{value}} »',
  errorTrackingId: 'ID de suivi : {{trackingId}}',
  saveDraft: 'Enregistrer le brouillon',
  checkAndActivate: 'Vérifier et activer',
  draftSaved: 'Brouillon enregistré.',
  activated: 'Champ personnalisé activé.',
  draftStatus: 'Brouillon',
  pendingDraftStatus: 'Brouillon de modification',
  translationCompleteness: '{{complete}} langues complètes sur {{total}}',
  translationCompletenessHint: 'Un brouillon incomplet peut être enregistré, mais pas activé.',
  autoTranslationTitle: 'Traduction automatique contrôlée',
  autoTranslationPrivacy:
    'Seuls les textes visibles des définitions sont envoyés au service Ollama local. Les résultats restent non enregistrés jusqu’à leur application.',
  translationSourceLanguage: 'Langue source',
  translateMissing: 'Traduire automatiquement les langues manquantes',
  retranslateWarning:
    'Créer de nouvelles propositions pour toutes les langues cibles ? Les textes existants ne changent qu’après votre application explicite.',
  retranslateAll: 'Tout retraduire',
  cancelTranslation: 'Annuler',
  translationProgress: '{{completed}} langues traitées sur {{total}}',
  retryTranslation: 'Réessayer',
  translateLanguage: 'Traduire',
  translationReady: 'Proposition prête',
  translationError: 'Échec',
  translationRunning: 'Traduction en cours',
  translationNotStarted: 'Non démarré',
  translationSourceMissing:
    'La langue source et toutes les options source visibles doivent être complètes.',
  autoTranslationFailed: 'Le service de traduction local n’a pas pu générer cette langue.',
  translationCancelled: 'La traduction a été annulée. Vous pouvez la relancer.',
  translationReviewOnApply: 'L’application explicite confirme votre contrôle métier.',
  translationReviewPermissionMissing:
    'Vous pouvez appliquer les propositions et enregistrer un brouillon ; la publication exige le droit de contrôle.',
  machineTranslation: 'Généré automatiquement',
  translationMemory: 'Issu de la mémoire de traduction contrôlée',
  translationReviewed: 'Contrôlé',
  translationReviewRequired: 'Contrôle requis',
  translationReviewBlocksActivation:
    'Les traductions automatiques doivent être contrôlées par une personne autorisée avant activation.',
  translationComparisonTitle: 'Comparaison {{source}} → {{target}}',
  translationComparisonHint:
    'Comparez la source, le texte existant et la proposition avant application.',
  discardSuggestion: 'Rejeter la proposition',
  applyChange: 'Appliquer la modification',
  sourceText: 'Texte source',
  existingTranslation: 'Traduction existante',
  suggestedTranslation: 'Traduction proposée',
  applyAllLanguageChanges: 'Appliquer toutes les modifications de cette langue',
  unsavedWarning: 'Abandonner les modifications non enregistrées ?',
  confidentiality: 'Confidentialité',
  confidentialities: { PUBLIC: 'Public', INTERNAL: 'Interne', CONFIDENTIAL: 'Confidentiel' },
  confidential: 'Confidentiel',
  optionTranslationsHint: 'Chaque option est traduite dans toutes les langues ERP.',
  optionValue: 'Valeur technique',
  defaultAndValidation: 'Valeur par défaut et validation',
  defaultValue: 'Valeur par défaut',
  noDefault: 'Aucune valeur par défaut',
  multiDefaultHint: 'Séparez les valeurs par des virgules.',
  minLength: 'Longueur minimale',
  maxLength: 'Longueur maximale',
  minimum: 'Minimum',
  maximum: 'Maximum',
  configurationLocked:
    '{{count}} valeurs utilisent ce champ. Sa clé, son type et ses options existantes sont protégés.',
  impactAffectedRecords: 'Enregistrements concernés',
  impactRisk: 'Risque de modification',
  impactContexts: 'Entités et rôles',
  impactUsageTitle: 'Utilisation de la définition publiée',
  impactNoUsage: 'Aucune utilisation actuelle trouvée.',
  impactUsages: {
    FORMS: 'Formulaires',
    LISTS: 'Listes',
    FILTERS: 'Filtres',
    FORMULAS: 'Formules',
    PDF_TEMPLATES: 'Modèles PDF',
    SPECIFICATIONS: 'Spécifications',
    IMPORT_PROFILES: 'Profils d’import',
    DOCUMENTS: 'Documents et lignes',
    AUTOMATIONS: 'Automatisations et segments',
  },
  impactChangesTitle: 'Modifications contrôlées',
  impactChanges: {
    KEY: 'Clé technique',
    FIELD_TYPE: 'Type de champ',
    OPTIONS: 'Valeurs ou ordre des options',
    FORMULA: 'Formule',
    SCOPE: 'Périmètre',
    REQUIRED: 'Règle de champ obligatoire',
    DEFAULT: 'Valeur par défaut',
    VISIBILITY: 'Règles d’affichage et de visibilité',
    TRANSLATIONS: 'Traductions',
  },
  impactRisks: { LOW: 'Faible', MEDIUM: 'Moyen', HIGH: 'Élevé' },
  impactMigrationTitle: 'Migration contrôlée requise',
  impactMigrationHint:
    'La définition publiée reste en place. Effectuez cette modification via un champ de remplacement afin de conserver la lisibilité des valeurs historiques.',
  impactMigrationSteps: {
    CREATE_REPLACEMENT: 'Créer un champ de remplacement avec la configuration voulue',
    MAP_VALUES: 'Associer explicitement les anciennes valeurs au champ de remplacement',
    VERIFY_VALUES: 'Contrôler le résultat et les configurations dépendantes',
    PUBLISH_REPLACEMENT: 'Publier le champ de remplacement contrôlé',
    ARCHIVE_ORIGINAL: 'Archiver le champ précédent',
  },
  impactConfirmTitle: 'Contrôler et publier la modification',
  impactConfirmDescription:
    'Contrôlez les enregistrements, les usages et le risque avant de publier le brouillon de modification.',
  impactPublish: 'Publier la modification contrôlée',
  impactAnalysisFailed:
    'L’impact de la modification n’a pas pu être contrôlé. Rien n’a été publié.',
  impactAnalysisFailedWithTrackingId:
    'L’impact de la modification n’a pas pu être contrôlé. Rien n’a été publié. ID de suivi : {{trackingId}}',
  impactOptionLocked:
    'Cette option possède des valeurs enregistrées. Utilisez le parcours de migration affiché pour la modifier.',
  publicationReason: 'Motif de publication',
  publicationReasonHint: 'Le motif, l’utilisateur et l’heure sont conservés dans la piste d’audit.',
  defaultPublicationReason: 'Modification contrôlée publiée depuis l’éditeur de champs.',
  versionHistoryTitle: 'Versions et publication',
  versionHistoryHint:
    'Les états antérieurs restent visibles ; un retour crée toujours un nouveau brouillon.',
  revision: 'Révision {{revision}}',
  versionStatuses: {
    DRAFT: 'Brouillon',
    IN_REVIEW: 'À contrôler',
    PUBLISHED: 'Publiée',
    SUPERSEDED: 'État antérieur',
  },
  versionReasonMissing: 'Aucun motif particulier enregistré.',
  versionComparisonTitle: 'Comparaison avec la version publiée',
  versionPublishedValue: 'Publiée',
  versionSelectedValue: 'Sélectionnée',
  versionIsPublished: 'Il s’agit de la version actuellement publiée.',
  versionNoPublished:
    'Ce champ archivé ou nouveau ne possède actuellement aucune version active publiée.',
  versionNoChanges: 'Aucune différence fonctionnelle avec la version publiée.',
  versionFields: {
    translations: 'Traductions',
    fieldType: 'Type de champ',
    options: 'Options',
    formulaExpression: 'Formule',
    entityTypes: 'Entités',
    partnerRoles: 'Rôles partenaire',
    isRequired: 'Champ obligatoire',
    defaultValue: 'Valeur par défaut',
    showInList: 'Affichage en liste',
    isFilterable: 'Filtre',
    showInPdf: 'Affichage PDF',
  },
  versionReason: 'Motif',
  versionReasonHint: 'Au moins trois caractères ; conservé dans la piste d’audit.',
  submitForReview: 'Soumettre au contrôle',
  rollbackAsDraft: 'Restaurer comme nouveau brouillon',
  inReviewStatus: 'À contrôler',
  pendingReviewStatus: 'Modification à contrôler',
  publishingSettingsTitle: 'Publication sécurisée',
  publishingSettingsHint: 'Contrôlez la publication des champs personnalisés pour ce mandant.',
  fourEyesEnabled: 'Activer le principe des quatre yeux',
  fourEyesDescription:
    'La personne qui soumet une révision ne peut pas publier cette même révision.',
  publishingSettingsSaved: 'Paramètre de publication enregistré.',
  transfer: {
    title: 'Export, import et gestion en masse',
    description:
      'Exportez les définitions et traductions, validez entièrement un fichier CSV/XLSX et importez-le uniquement comme brouillon.',
    exportXlsx: 'Exporter en XLSX',
    exportCsv: 'Exporter en CSV',
    selectFile: 'Choisir le fichier à importer',
    uploading: 'Validation du fichier …',
    previewHint: 'Un import ne démarre qu’après l’aperçu serveur et votre confirmation.',
    previewTitle: 'Aperçu de l’import',
    resultTitle: 'Résultat de l’import',
    errorReport: 'Télécharger le rapport d’erreurs',
    counts: {
      total: 'Total',
      new: 'Nouveau',
      changed: 'Modifié',
      unchanged: 'Inchangé',
      invalid: 'Erroné',
    },
    errorSummary: '{{count}} erreurs d’import doivent être corrigées.',
    errorLine: 'Ligne {{row}}, colonne {{column}} : {{message}}',
    row: 'Ligne',
    key: 'Clé du champ',
    area: 'Domaine',
    label: 'Libellé',
    status: 'Résultat',
    statuses: { NEW: 'Nouveau', CHANGED: 'Modifié', UNCHANGED: 'Inchangé', INVALID: 'Erroné' },
    confirmDraftImport:
      'J’ai vérifié l’aperçu et importe les définitions nouvelles ou modifiées comme brouillons.',
    generateMissing: 'Générer les traductions manquantes dans une tâche contrôlée après l’import',
    sourceLocale: 'Langue source',
    draftOnly: 'L’import n’active aucune définition et ne remplace aucune version publiée.',
    importing: 'Import en cours …',
    execute: 'Exécuter l’import vérifié',
    completed:
      '{{created}} nouveaux et {{changed}} brouillons modifiés importés ; {{invalid}} lignes en échec.',
    translationJob: 'Tâche de traduction',
    translationProgress: 'Progression de la traduction automatique',
    translationCounts: '{{done}} sur {{total}} traités, {{failed}} en échec',
    retry: 'Reprendre la tâche',
  },
  quality: {
    title: 'Qualité de la configuration',
    description:
      'Repérer les problèmes de traduction, de formule, d’utilisation et de traitement, puis les ouvrir directement.',
    refresh: 'Vérifier à nouveau',
    category: 'Catégorie',
    language: 'Langue',
    status: 'Statut',
    metrics: {
      activeDefinitions: 'Champs personnalisés actifs',
      incompleteDrafts: 'Brouillons incomplets',
      missingTranslations: 'Traductions manquantes',
      unreviewedMachineTranslations: 'Traductions automatiques non contrôlées',
      invalidFormulas: 'Formules invalides',
      unusedDefinitions: 'Champs inutilisés',
      archiveCandidates: 'Candidats à l’archivage',
      definitionConflicts: 'Conflits de définition',
      failedTranslationJobs: 'Tâches de traduction échouées',
    },
    byLanguage: 'Complétude par langue',
    languageProgress: 'Progression des traductions pour {{language}}',
    languageSummary: '{{complete}} sur {{total}} complets · {{missing}} textes manquants',
    issues: 'Actions requises',
    noIssues: 'Aucune action n’est requise pour les filtres sélectionnés.',
    translationJob: 'Tâche de traduction',
    issueKinds: {
      MISSING_TRANSLATION: '{{count}} traductions manquantes',
      UNREVIEWED_MACHINE_TRANSLATION: '{{count}} traductions automatiques non contrôlées',
      INVALID_FORMULA: 'Formule invalide',
      UNUSED_DEFINITION: 'Inutilisé',
      ARCHIVE_CANDIDATE: 'Inutilisé depuis au moins 180 jours',
      DEFINITION_CONFLICT: '{{count}} conflits de définition',
      FAILED_TRANSLATION_JOB: '{{count}} traductions échouées',
    },
    trackingId: 'ID de suivi : {{trackingId}}',
    open: 'Ouvrir',
    generatedAt: 'Dernière vérification : {{date}}',
  },
  showArchived: 'Afficher les archives',
  showPreview: 'Afficher l’aperçu',
  noGroups: 'Aucune catégorie pour ce domaine',
  noGroupsHint: 'Créez une catégorie puis attribuez-lui des champs.',
  dragGroup: 'Déplacer la catégorie',
  dragField: 'Déplacer le champ',
  dropFieldHere: 'Déposez un champ ici ou créez-en un.',
  archivedStatus: 'Archivé',
  fieldCount: '{{count}} champs',
  valueCount: '{{count}} valeurs',
  masterDataPreview: 'Aperçu des données de base',
  masterDataPreviewHint: 'Présentation selon la largeur de carte et la disposition choisies.',
  usagePreviewContext: 'Contexte d’utilisation',
  usagePreviewLanguage: 'Langue de l’aperçu',
  usagePreviewViewport: 'Affichage',
  usagePreviewViewports: { DESKTOP: 'Ordinateur', TABLET: 'Tablette', MOBILE: 'Mobile' },
  usagePreviewCanvas: 'Aperçu d’utilisation localisé',
  usagePreviewSafeSample: 'Aperçu sans données métier',
  usagePreviewMissingCategory: 'Catégorie manquante',
  usagePreviewNoWarnings: 'Aucun avertissement détecté pour ce contexte.',
  usagePreviewWarnings: '{{count}} avertissements d’aperçu',
  usagePreviewWarningDetails: {
    label: 'libellé',
    category: 'nom de catégorie',
    options: 'options',
  },
  usagePreviewWarning: {
    MISSING_TRANSLATION: 'Un texte visible manque dans cette langue ({{detail}}).',
    LABEL_TOO_LONG: 'Le libellé risque d’être trop long avec {{detail}} caractères.',
    DUPLICATE_LABEL: 'Un autre champ utilise le même libellé dans cette zone.',
    INVALID_DEFAULT: 'La valeur par défaut ne correspond pas au type ou aux options.',
    EMPTY_OPTION: 'Au moins une option visible est vide ou manquante.',
    VISIBILITY_CONFLICT: 'Les règles de portée et d’affichage se contredisent.',
    INVALID_FORMULA: 'La formule ne peut pas être évaluée.',
  },
  emptyGroup: 'Cette catégorie ne contient aucun champ.',
  groupArchiveTitle: 'Archiver la catégorie',
  archiveImpactDescription:
    'Le champ « {{label}} » est masqué pour les nouvelles saisies. {{valueCount}} valeurs restent lisibles.',
  groupArchiveDescription:
    'La catégorie « {{label}} » et ses {{fieldCount}} champs sont masqués pour les nouvelles saisies.',
  archivePreservesHistory:
    'Les valeurs historiques, instantanés, exports et journaux d’audit ne sont pas supprimés.',
  archiveImpact: 'Concernés : {{fieldCount}} champs et {{valueCount}} valeurs enregistrées.',
} as const;

export const customFieldBuilderEs = {
  builderSubtitle: 'Gestione categorías, ámbitos, traducciones y presentación en un solo lugar.',
  area: 'Área funcional',
  createGroup: 'Nueva categoría',
  groupCreated: 'Categoría creada.',
  groupUpdated: 'Categoría guardada.',
  groupArchived: 'Categoría archivada.',
  groupCreateTitle: 'Crear categoría',
  groupEditTitle: 'Editar categoría',
  groupDialogDescription: 'Las categorías agrupan campos en la vista de datos maestros.',
  name: 'Nombre',
  icon: 'Clave de icono',
  color: 'Color',
  scope: 'Ámbitos',
  partnerRoles: 'Roles del socio',
  partnerRolesHint: 'Sin selección se aplica a todos los roles.',
  roles: { CUSTOMER: 'Cliente', PROSPECT: 'Cliente potencial', SUPPLIER: 'Proveedor' },
  layoutWidth: 'Ancho de tarjeta',
  widthFull: 'Ancho completo',
  widthHalf: 'Medio ancho',
  fieldLayout: 'Diseño de campos',
  oneColumn: 'Una columna',
  twoColumns: 'Dos columnas',
  active: 'Activo',
  defaultExpanded: 'Abierto de forma predeterminada',
  hideEmptyInDetail: 'Ocultar valores vacíos en detalle',
  readPermissions: 'Permisos de lectura adicionales',
  writePermissions: 'Permisos de escritura adicionales',
  permissionsHint: 'Sin selección no hay restricción adicional.',
  helpText: 'Ayuda contextual',
  translationRequired: 'Falta esta traducción o solo contiene espacios.',
  translationDuplicate: 'Esta traducción está duplicada dentro del idioma.',
  translationStatusComplete: 'Completo',
  translationStatusIncomplete: 'Incompleto',
  translationValidationTitle: 'El campo adicional aún no se puede guardar.',
  groupTranslationValidationTitle: 'La categoría de campos adicionales aún no se puede guardar.',
  translationValidationCount: 'Faltan o entran en conflicto {{count}} traducciones:',
  translationFields: {
    label: 'Etiqueta',
    description: 'Descripción',
    helpText: 'Texto de ayuda',
    name: 'Etiqueta de categoría',
  },
  translationFieldOption: 'Opción «{{value}}»',
  errorTrackingId: 'ID de seguimiento: {{trackingId}}',
  saveDraft: 'Guardar borrador',
  checkAndActivate: 'Comprobar y activar',
  draftSaved: 'Borrador guardado.',
  activated: 'Campo adicional activado.',
  draftStatus: 'Borrador',
  pendingDraftStatus: 'Borrador de cambios',
  translationCompleteness: '{{complete}} de {{total}} idiomas completos',
  translationCompletenessHint: 'Los borradores incompletos se pueden guardar, pero no activar.',
  autoTranslationTitle: 'Traducción automática controlada',
  autoTranslationPrivacy:
    'Solo se envían textos visibles de las definiciones al servicio Ollama local. Los resultados no se guardan hasta que los aplique.',
  translationSourceLanguage: 'Idioma de origen',
  translateMissing: 'Traducir automáticamente los idiomas que faltan',
  retranslateWarning:
    '¿Generar propuestas nuevas para todos los idiomas de destino? Los textos existentes solo cambiarán cuando aplique una propuesta expresamente.',
  retranslateAll: 'Volver a traducir todo',
  cancelTranslation: 'Cancelar',
  translationProgress: '{{completed}} de {{total}} idiomas procesados',
  retryTranslation: 'Reintentar',
  translateLanguage: 'Traducir',
  translationReady: 'Propuesta lista',
  translationError: 'Error',
  translationRunning: 'Traduciendo',
  translationNotStarted: 'Sin iniciar',
  translationSourceMissing:
    'El idioma de origen y todas las opciones de origen visibles deben estar completos.',
  autoTranslationFailed: 'El servicio de traducción local no pudo generar este idioma.',
  translationCancelled: 'La traducción se canceló. Puede volver a intentarlo.',
  translationReviewOnApply: 'La aplicación expresa confirma su revisión especializada.',
  translationReviewPermissionMissing:
    'Puede aplicar propuestas y guardar un borrador; la publicación requiere permiso de revisión.',
  machineTranslation: 'Generada automáticamente',
  translationMemory: 'De la memoria de traducción revisada',
  translationReviewed: 'Revisada',
  translationReviewRequired: 'Revisión necesaria',
  translationReviewBlocksActivation:
    'Las traducciones automáticas necesitan una revisión autorizada antes de la activación.',
  translationComparisonTitle: 'Comparación {{source}} → {{target}}',
  translationComparisonHint:
    'Compare el origen, el texto existente y la propuesta antes de aplicarla.',
  discardSuggestion: 'Descartar propuesta',
  applyChange: 'Aplicar cambio',
  sourceText: 'Texto de origen',
  existingTranslation: 'Traducción existente',
  suggestedTranslation: 'Traducción propuesta',
  applyAllLanguageChanges: 'Aplicar todos los cambios de este idioma',
  unsavedWarning: '¿Descartar los cambios no guardados?',
  confidentiality: 'Confidencialidad',
  confidentialities: { PUBLIC: 'Público', INTERNAL: 'Interno', CONFIDENTIAL: 'Confidencial' },
  confidential: 'Confidencial',
  optionTranslationsHint: 'Mantenga cada opción en todos los idiomas del ERP.',
  optionValue: 'Valor técnico',
  defaultAndValidation: 'Valor predeterminado y validación',
  defaultValue: 'Valor predeterminado',
  noDefault: 'Sin valor predeterminado',
  multiDefaultHint: 'Separe varios valores con comas.',
  minLength: 'Longitud mínima',
  maxLength: 'Longitud máxima',
  minimum: 'Mínimo',
  maximum: 'Máximo',
  configurationLocked:
    '{{count}} valores usan este campo. Su clave, tipo y opciones existentes están protegidos.',
  impactAffectedRecords: 'Registros afectados',
  impactRisk: 'Riesgo del cambio',
  impactContexts: 'Entidades y roles',
  impactUsageTitle: 'Uso de la definición publicada',
  impactNoUsage: 'No se encontró ningún uso actual.',
  impactUsages: {
    FORMS: 'Formularios',
    LISTS: 'Listas',
    FILTERS: 'Filtros',
    FORMULAS: 'Fórmulas',
    PDF_TEMPLATES: 'Plantillas PDF',
    SPECIFICATIONS: 'Especificaciones',
    IMPORT_PROFILES: 'Perfiles de importación',
    DOCUMENTS: 'Documentos y líneas',
    AUTOMATIONS: 'Automatizaciones y segmentos',
  },
  impactChangesTitle: 'Cambios comprobados',
  impactChanges: {
    KEY: 'Clave técnica',
    FIELD_TYPE: 'Tipo de campo',
    OPTIONS: 'Valores u orden de opciones',
    FORMULA: 'Fórmula',
    SCOPE: 'Ámbito',
    REQUIRED: 'Regla de campo obligatorio',
    DEFAULT: 'Valor predeterminado',
    VISIBILITY: 'Reglas de presentación y visibilidad',
    TRANSLATIONS: 'Traducciones',
  },
  impactRisks: { LOW: 'Bajo', MEDIUM: 'Medio', HIGH: 'Alto' },
  impactMigrationTitle: 'Se requiere una migración controlada',
  impactMigrationHint:
    'La definición publicada permanece. Realice el cambio mediante un campo de reemplazo para conservar legibles los valores históricos.',
  impactMigrationSteps: {
    CREATE_REPLACEMENT: 'Crear un campo de reemplazo con la configuración deseada',
    MAP_VALUES: 'Asignar explícitamente los valores anteriores al campo de reemplazo',
    VERIFY_VALUES: 'Comprobar el resultado y las configuraciones dependientes',
    PUBLISH_REPLACEMENT: 'Publicar el campo de reemplazo revisado',
    ARCHIVE_ORIGINAL: 'Archivar el campo anterior',
  },
  impactConfirmTitle: 'Revisar y publicar el cambio',
  impactConfirmDescription:
    'Revise registros, usos y riesgo antes de publicar el borrador de cambios.',
  impactPublish: 'Publicar el cambio revisado',
  impactAnalysisFailed: 'No se pudo comprobar el impacto. No se publicó ningún cambio.',
  impactAnalysisFailedWithTrackingId:
    'No se pudo comprobar el impacto. No se publicó ningún cambio. ID de seguimiento: {{trackingId}}',
  impactOptionLocked:
    'Esta opción tiene valores guardados. Use el proceso de migración mostrado para modificarla.',
  publicationReason: 'Motivo de publicación',
  publicationReasonHint: 'El motivo, el usuario y la hora se guardan en la auditoría.',
  defaultPublicationReason: 'Cambio revisado publicado desde el editor de campos.',
  versionHistoryTitle: 'Versiones y publicación',
  versionHistoryHint:
    'Los estados anteriores siguen visibles; una reversión siempre crea un borrador nuevo.',
  revision: 'Revisión {{revision}}',
  versionStatuses: {
    DRAFT: 'Borrador',
    IN_REVIEW: 'En revisión',
    PUBLISHED: 'Publicada',
    SUPERSEDED: 'Estado anterior',
  },
  versionReasonMissing: 'No se registró un motivo específico.',
  versionComparisonTitle: 'Comparación con la versión publicada',
  versionPublishedValue: 'Publicada',
  versionSelectedValue: 'Seleccionada',
  versionIsPublished: 'Esta es la versión publicada actualmente.',
  versionNoPublished:
    'Este campo archivado o nuevo no tiene actualmente una versión activa publicada.',
  versionNoChanges: 'No hay diferencias funcionales con la versión publicada.',
  versionFields: {
    translations: 'Traducciones',
    fieldType: 'Tipo de campo',
    options: 'Opciones',
    formulaExpression: 'Fórmula',
    entityTypes: 'Entidades',
    partnerRoles: 'Roles de socio',
    isRequired: 'Campo obligatorio',
    defaultValue: 'Valor predeterminado',
    showInList: 'Visualización en lista',
    isFilterable: 'Filtro',
    showInPdf: 'Visualización PDF',
  },
  versionReason: 'Motivo',
  versionReasonHint: 'Al menos tres caracteres; se guarda en la auditoría.',
  submitForReview: 'Enviar a revisión',
  rollbackAsDraft: 'Restaurar como borrador nuevo',
  inReviewStatus: 'En revisión',
  pendingReviewStatus: 'Cambio en revisión',
  publishingSettingsTitle: 'Publicación segura',
  publishingSettingsHint: 'Controle la publicación de campos adicionales para este inquilino.',
  fourEyesEnabled: 'Activar el principio de cuatro ojos',
  fourEyesDescription: 'Quien envía una revisión no puede publicar esa misma revisión.',
  publishingSettingsSaved: 'Configuración de publicación guardada.',
  transfer: {
    title: 'Exportación, importación y edición masiva',
    description:
      'Exporte definiciones y traducciones, valide por completo un CSV/XLSX e impórtelo solo como borradores.',
    exportXlsx: 'Exportar XLSX',
    exportCsv: 'Exportar CSV',
    selectFile: 'Seleccionar archivo de importación',
    uploading: 'Validando archivo …',
    previewHint:
      'La importación solo se ejecuta después de la vista previa del servidor y su confirmación.',
    previewTitle: 'Vista previa de importación',
    resultTitle: 'Resultado de importación',
    errorReport: 'Descargar informe de errores',
    counts: {
      total: 'Total',
      new: 'Nuevo',
      changed: 'Modificado',
      unchanged: 'Sin cambios',
      invalid: 'Erróneo',
    },
    errorSummary: 'Deben corregirse {{count}} errores de importación.',
    errorLine: 'Fila {{row}}, columna {{column}}: {{message}}',
    row: 'Fila',
    key: 'Clave de campo',
    area: 'Área',
    label: 'Etiqueta',
    status: 'Resultado',
    statuses: { NEW: 'Nuevo', CHANGED: 'Modificado', UNCHANGED: 'Sin cambios', INVALID: 'Erróneo' },
    confirmDraftImport:
      'He revisado la vista previa e importo las definiciones nuevas o modificadas como borradores.',
    generateMissing: 'Generar traducciones ausentes en una tarea controlada después de importar',
    sourceLocale: 'Idioma de origen',
    draftOnly: 'La importación no activa definiciones ni sobrescribe versiones publicadas.',
    importing: 'Importando …',
    execute: 'Ejecutar importación revisada',
    completed:
      '{{created}} borradores nuevos y {{changed}} modificados importados; {{invalid}} filas fallaron.',
    translationJob: 'Tarea de traducción',
    translationProgress: 'Progreso de la traducción automática',
    translationCounts: '{{done}} de {{total}} procesados, {{failed}} fallidos',
    retry: 'Reanudar tarea',
  },
  quality: {
    title: 'Calidad de la configuración',
    description:
      'Detectar problemas pendientes de traducción, fórmulas, uso y tareas, y abrirlos directamente.',
    refresh: 'Comprobar de nuevo',
    category: 'Categoría',
    language: 'Idioma',
    status: 'Estado',
    metrics: {
      activeDefinitions: 'Campos personalizados activos',
      incompleteDrafts: 'Borradores incompletos',
      missingTranslations: 'Traducciones que faltan',
      unreviewedMachineTranslations: 'Traducciones automáticas sin revisar',
      invalidFormulas: 'Fórmulas no válidas',
      unusedDefinitions: 'Campos sin usar',
      archiveCandidates: 'Candidatos a archivar',
      definitionConflicts: 'Conflictos de definición',
      failedTranslationJobs: 'Tareas de traducción fallidas',
    },
    byLanguage: 'Completitud por idioma',
    languageProgress: 'Progreso de traducción para {{language}}',
    languageSummary: '{{complete}} de {{total}} completos · faltan {{missing}} textos',
    issues: 'Acciones necesarias',
    noIssues: 'No se requieren acciones para los filtros seleccionados.',
    translationJob: 'Tarea de traducción',
    issueKinds: {
      MISSING_TRANSLATION: 'Faltan {{count}} traducciones',
      UNREVIEWED_MACHINE_TRANSLATION: '{{count}} traducciones automáticas sin revisar',
      INVALID_FORMULA: 'Fórmula no válida',
      UNUSED_DEFINITION: 'Sin usar',
      ARCHIVE_CANDIDATE: 'Sin usar desde hace al menos 180 días',
      DEFINITION_CONFLICT: '{{count}} conflictos de definición',
      FAILED_TRANSLATION_JOB: '{{count}} traducciones fallidas',
    },
    trackingId: 'ID de seguimiento: {{trackingId}}',
    open: 'Abrir',
    generatedAt: 'Última comprobación: {{date}}',
  },
  showArchived: 'Mostrar archivados',
  showPreview: 'Mostrar vista previa',
  noGroups: 'Aún no hay categoría para esta área',
  noGroupsHint: 'Cree una categoría y después asígnele campos.',
  dragGroup: 'Mover categoría',
  dragField: 'Mover campo',
  dropFieldHere: 'Arrastre un campo aquí o cree uno nuevo.',
  archivedStatus: 'Archivado',
  fieldCount: '{{count}} campos',
  valueCount: '{{count}} valores',
  masterDataPreview: 'Vista previa de datos maestros',
  masterDataPreviewHint: 'Presentación con el ancho de tarjeta y diseño seleccionados.',
  usagePreviewContext: 'Contexto de uso',
  usagePreviewLanguage: 'Idioma de vista previa',
  usagePreviewViewport: 'Vista',
  usagePreviewViewports: { DESKTOP: 'Escritorio', TABLET: 'Tableta', MOBILE: 'Móvil' },
  usagePreviewCanvas: 'Vista previa de uso localizada',
  usagePreviewSafeSample: 'Vista previa sin datos comerciales',
  usagePreviewMissingCategory: 'Falta la categoría',
  usagePreviewNoWarnings: 'No se detectaron avisos de vista previa para este contexto.',
  usagePreviewWarnings: '{{count}} avisos de vista previa',
  usagePreviewWarningDetails: {
    label: 'etiqueta',
    category: 'nombre de categoría',
    options: 'opciones',
  },
  usagePreviewWarning: {
    MISSING_TRANSLATION: 'Falta un texto visible en este idioma ({{detail}}).',
    LABEL_TOO_LONG: 'La etiqueta puede ser demasiado larga con {{detail}} caracteres.',
    DUPLICATE_LABEL: 'Otro campo usa la misma etiqueta en esta área.',
    INVALID_DEFAULT: 'El valor predeterminado no coincide con el tipo o las opciones.',
    EMPTY_OPTION: 'Al menos una opción visible está vacía o falta.',
    VISIBILITY_CONFLICT: 'Las reglas de ámbito y visualización se contradicen.',
    INVALID_FORMULA: 'No se puede evaluar la fórmula.',
  },
  emptyGroup: 'Esta categoría aún no contiene campos.',
  groupArchiveTitle: 'Archivar categoría',
  archiveImpactDescription:
    'El campo «{{label}}» se oculta para nuevas entradas. {{valueCount}} valores permanecen legibles.',
  groupArchiveDescription:
    'La categoría «{{label}}» y sus {{fieldCount}} campos se ocultan para nuevas entradas.',
  archivePreservesHistory:
    'No se eliminan valores históricos, instantáneas, exportaciones ni auditorías.',
  archiveImpact: 'Afectados: {{fieldCount}} campos y {{valueCount}} valores guardados.',
} as const;

export const customFieldBuilderRu = {
  builderSubtitle: 'Управление категориями, областями, переводами и отображением.',
  area: 'Предметная область',
  createGroup: 'Новая категория',
  groupCreated: 'Категория создана.',
  groupUpdated: 'Категория сохранена.',
  groupArchived: 'Категория архивирована.',
  groupCreateTitle: 'Создать категорию',
  groupEditTitle: 'Изменить категорию',
  groupDialogDescription: 'Категории группируют поля в карточках основных данных.',
  name: 'Название',
  icon: 'Ключ значка',
  color: 'Цвет',
  scope: 'Области действия',
  partnerRoles: 'Роли партнёра',
  partnerRolesHint: 'Без выбора настройка действует для всех ролей.',
  roles: { CUSTOMER: 'Клиент', PROSPECT: 'Потенциальный клиент', SUPPLIER: 'Поставщик' },
  layoutWidth: 'Ширина карточки',
  widthFull: 'Полная ширина',
  widthHalf: 'Половина ширины',
  fieldLayout: 'Расположение полей',
  oneColumn: 'Одна колонка',
  twoColumns: 'Две колонки',
  active: 'Активно',
  defaultExpanded: 'Открыто по умолчанию',
  hideEmptyInDetail: 'Скрывать пустые значения в просмотре',
  readPermissions: 'Дополнительные права чтения',
  writePermissions: 'Дополнительные права записи',
  permissionsHint: 'Без выбора дополнительных ограничений нет.',
  helpText: 'Контекстная справка',
  translationRequired: 'Перевод отсутствует или состоит только из пробелов.',
  translationDuplicate: 'Этот перевод повторяется в пределах языка.',
  translationStatusComplete: 'Заполнено',
  translationStatusIncomplete: 'Не заполнено',
  translationValidationTitle: 'Дополнительное поле пока нельзя сохранить.',
  groupTranslationValidationTitle: 'Категорию дополнительных полей пока нельзя сохранить.',
  translationValidationCount: 'Отсутствуют или конфликтуют переводы: {{count}}.',
  translationFields: {
    label: 'Название',
    description: 'Описание',
    helpText: 'Текст справки',
    name: 'Название категории',
  },
  translationFieldOption: 'Вариант «{{value}}»',
  errorTrackingId: 'Идентификатор отслеживания: {{trackingId}}',
  saveDraft: 'Сохранить черновик',
  checkAndActivate: 'Проверить и активировать',
  draftSaved: 'Черновик сохранён.',
  activated: 'Дополнительное поле активировано.',
  draftStatus: 'Черновик',
  pendingDraftStatus: 'Черновик изменений',
  translationCompleteness: 'Заполнено языков: {{complete}} из {{total}}',
  translationCompletenessHint: 'Неполный черновик можно сохранить, но нельзя активировать.',
  autoTranslationTitle: 'Контролируемый автоматический перевод',
  autoTranslationPrivacy:
    'Локальному сервису Ollama передаются только видимые тексты определений. Результаты не сохраняются, пока вы их не примените.',
  translationSourceLanguage: 'Исходный язык',
  translateMissing: 'Автоматически перевести отсутствующие языки',
  retranslateWarning:
    'Создать новые предложения для всех целевых языков? Существующие тексты изменятся только после явного применения.',
  retranslateAll: 'Перевести всё заново',
  cancelTranslation: 'Отменить',
  translationProgress: 'Обработано языков: {{completed}} из {{total}}',
  retryTranslation: 'Повторить',
  translateLanguage: 'Перевести',
  translationReady: 'Предложение готово',
  translationError: 'Ошибка',
  translationRunning: 'Выполняется перевод',
  translationNotStarted: 'Не запущено',
  translationSourceMissing: 'Исходный язык и все видимые исходные варианты должны быть заполнены.',
  autoTranslationFailed: 'Локальный сервис перевода не смог создать перевод на этот язык.',
  translationCancelled: 'Перевод отменён. Его можно запустить повторно.',
  translationReviewOnApply: 'Явное применение подтверждает вашу предметную проверку.',
  translationReviewPermissionMissing:
    'Предложения можно применить и сохранить как черновик; для публикации требуется право проверки.',
  machineTranslation: 'Машинный перевод',
  translationMemory: 'Из проверенной памяти переводов',
  translationReviewed: 'Проверено',
  translationReviewRequired: 'Требуется проверка',
  translationReviewBlocksActivation:
    'Перед активацией машинные переводы должен проверить уполномоченный пользователь.',
  translationComparisonTitle: 'Сравнение {{source}} → {{target}}',
  translationComparisonHint:
    'Перед применением сравните источник, существующий текст и предложение.',
  discardSuggestion: 'Отклонить предложение',
  applyChange: 'Применить изменение',
  sourceText: 'Исходный текст',
  existingTranslation: 'Существующий перевод',
  suggestedTranslation: 'Предложенный перевод',
  applyAllLanguageChanges: 'Применить все изменения для этого языка',
  unsavedWarning: 'Отменить несохранённые изменения?',
  confidentiality: 'Конфиденциальность',
  confidentialities: {
    PUBLIC: 'Общедоступно',
    INTERNAL: 'Внутреннее',
    CONFIDENTIAL: 'Конфиденциально',
  },
  confidential: 'Конфиденциально',
  optionTranslationsHint: 'Каждый вариант задаётся на всех языках ERP.',
  optionValue: 'Техническое значение',
  defaultAndValidation: 'Значение по умолчанию и проверка',
  defaultValue: 'Значение по умолчанию',
  noDefault: 'Без значения по умолчанию',
  multiDefaultHint: 'Разделяйте значения запятыми.',
  minLength: 'Минимальная длина',
  maxLength: 'Максимальная длина',
  minimum: 'Минимум',
  maximum: 'Максимум',
  configurationLocked:
    'Это поле используется в {{count}} значениях. Ключ, тип и существующие варианты защищены.',
  impactAffectedRecords: 'Затронутые записи',
  impactRisk: 'Риск изменения',
  impactContexts: 'Сущности и роли',
  impactUsageTitle: 'Использование опубликованного определения',
  impactNoUsage: 'Текущие использования не найдены.',
  impactUsages: {
    FORMS: 'Формы',
    LISTS: 'Списки',
    FILTERS: 'Фильтры',
    FORMULAS: 'Формулы',
    PDF_TEMPLATES: 'Шаблоны PDF',
    SPECIFICATIONS: 'Спецификации',
    IMPORT_PROFILES: 'Профили импорта',
    DOCUMENTS: 'Документы и позиции',
    AUTOMATIONS: 'Автоматизации и сегменты',
  },
  impactChangesTitle: 'Проверенные изменения',
  impactChanges: {
    KEY: 'Технический ключ',
    FIELD_TYPE: 'Тип поля',
    OPTIONS: 'Значения или порядок вариантов',
    FORMULA: 'Формула',
    SCOPE: 'Область действия',
    REQUIRED: 'Правило обязательности',
    DEFAULT: 'Значение по умолчанию',
    VISIBILITY: 'Правила отображения и видимости',
    TRANSLATIONS: 'Переводы',
  },
  impactRisks: { LOW: 'Низкий', MEDIUM: 'Средний', HIGH: 'Высокий' },
  impactMigrationTitle: 'Требуется контролируемый переход',
  impactMigrationHint:
    'Опубликованное определение сохраняется. Выполните изменение через поле-замену, чтобы исторические значения оставались читаемыми.',
  impactMigrationSteps: {
    CREATE_REPLACEMENT: 'Создать поле-замену с нужной конфигурацией',
    MAP_VALUES: 'Явно сопоставить старые значения с полем-заменой',
    VERIFY_VALUES: 'Проверить результат и зависимые настройки',
    PUBLISH_REPLACEMENT: 'Опубликовать проверенное поле-замену',
    ARCHIVE_ORIGINAL: 'Архивировать прежнее поле',
  },
  impactConfirmTitle: 'Проверить и опубликовать изменение',
  impactConfirmDescription:
    'Проверьте записи, использования и риск перед публикацией черновика изменений.',
  impactPublish: 'Опубликовать проверенное изменение',
  impactAnalysisFailed: 'Не удалось проверить влияние изменения. Ничего не опубликовано.',
  impactAnalysisFailedWithTrackingId:
    'Не удалось проверить влияние изменения. Ничего не опубликовано. Идентификатор: {{trackingId}}',
  impactOptionLocked:
    'Для этого варианта сохранены значения. Используйте показанный путь миграции для изменения.',
  publicationReason: 'Причина публикации',
  publicationReasonHint: 'Причина, пользователь и время сохраняются в журнале аудита.',
  defaultPublicationReason: 'Проверенное изменение опубликовано из редактора полей.',
  versionHistoryTitle: 'Версии и публикация',
  versionHistoryHint:
    'Предыдущие состояния остаются доступными; откат всегда создаёт новый черновик.',
  revision: 'Редакция {{revision}}',
  versionStatuses: {
    DRAFT: 'Черновик',
    IN_REVIEW: 'На проверке',
    PUBLISHED: 'Опубликовано',
    SUPERSEDED: 'Предыдущая версия',
  },
  versionReasonMissing: 'Отдельная причина не указана.',
  versionComparisonTitle: 'Сравнение с опубликованной версией',
  versionPublishedValue: 'Опубликовано',
  versionSelectedValue: 'Выбрано',
  versionIsPublished: 'Это текущая опубликованная версия.',
  versionNoPublished:
    'У этого архивного или нового поля сейчас нет активной опубликованной версии.',
  versionNoChanges: 'Функциональных отличий от опубликованной версии нет.',
  versionFields: {
    translations: 'Переводы',
    fieldType: 'Тип поля',
    options: 'Варианты',
    formulaExpression: 'Формула',
    entityTypes: 'Сущности',
    partnerRoles: 'Роли партнёра',
    isRequired: 'Обязательное поле',
    defaultValue: 'Значение по умолчанию',
    showInList: 'Отображение в списке',
    isFilterable: 'Фильтр',
    showInPdf: 'Отображение в PDF',
  },
  versionReason: 'Причина',
  versionReasonHint: 'Не менее трёх символов; сохраняется в журнале аудита.',
  submitForReview: 'Отправить на проверку',
  rollbackAsDraft: 'Восстановить новым черновиком',
  inReviewStatus: 'На проверке',
  pendingReviewStatus: 'Изменение на проверке',
  publishingSettingsTitle: 'Безопасная публикация',
  publishingSettingsHint: 'Управляйте публикацией дополнительных полей для этого клиента.',
  fourEyesEnabled: 'Включить принцип четырёх глаз',
  fourEyesDescription: 'Отправивший редакцию пользователь не может сам её опубликовать.',
  publishingSettingsSaved: 'Настройка публикации сохранена.',
  transfer: {
    title: 'Экспорт, импорт и массовое редактирование',
    description:
      'Экспортируйте определения и переводы, полностью проверьте CSV/XLSX и импортируйте данные только как черновики.',
    exportXlsx: 'Экспорт XLSX',
    exportCsv: 'Экспорт CSV',
    selectFile: 'Выбрать файл импорта',
    uploading: 'Проверка файла …',
    previewHint: 'Импорт выполняется только после серверного предпросмотра и вашего подтверждения.',
    previewTitle: 'Предпросмотр импорта',
    resultTitle: 'Результат импорта',
    errorReport: 'Скачать отчёт об ошибках',
    counts: {
      total: 'Всего',
      new: 'Новые',
      changed: 'Изменённые',
      unchanged: 'Без изменений',
      invalid: 'Ошибочные',
    },
    errorSummary: 'Необходимо исправить ошибок импорта: {{count}}.',
    errorLine: 'Строка {{row}}, столбец {{column}}: {{message}}',
    row: 'Строка',
    key: 'Ключ поля',
    area: 'Область',
    label: 'Название',
    status: 'Результат',
    statuses: { NEW: 'Новое', CHANGED: 'Изменено', UNCHANGED: 'Без изменений', INVALID: 'Ошибка' },
    confirmDraftImport:
      'Я проверил предпросмотр и импортирую новые или изменённые определения как черновики.',
    generateMissing: 'Создать недостающие переводы контролируемым фоновым заданием после импорта',
    sourceLocale: 'Исходный язык',
    draftOnly: 'Импорт не активирует определения и не перезаписывает опубликованные версии.',
    importing: 'Выполняется импорт …',
    execute: 'Выполнить проверенный импорт',
    completed:
      'Импортировано новых черновиков: {{created}}, изменённых: {{changed}}; ошибок строк: {{invalid}}.',
    translationJob: 'Задание перевода',
    translationProgress: 'Ход автоматического перевода',
    translationCounts: 'Обработано {{done}} из {{total}}, ошибок: {{failed}}',
    retry: 'Продолжить задание',
  },
  quality: {
    title: 'Качество конфигурации',
    description:
      'Находите проблемы переводов, формул, использования и заданий и сразу переходите к ним.',
    refresh: 'Проверить снова',
    category: 'Категория',
    language: 'Язык',
    status: 'Статус',
    metrics: {
      activeDefinitions: 'Активные пользовательские поля',
      incompleteDrafts: 'Неполные черновики',
      missingTranslations: 'Отсутствующие переводы',
      unreviewedMachineTranslations: 'Непроверенные машинные переводы',
      invalidFormulas: 'Недопустимые формулы',
      unusedDefinitions: 'Неиспользуемые поля',
      archiveCandidates: 'Кандидаты на архивирование',
      definitionConflicts: 'Конфликты определений',
      failedTranslationJobs: 'Неудачные задания перевода',
    },
    byLanguage: 'Полнота по языкам',
    languageProgress: 'Ход перевода для {{language}}',
    languageSummary: '{{complete}} из {{total}} заполнено · отсутствует текстов: {{missing}}',
    issues: 'Требуются действия',
    noIssues: 'Для выбранных фильтров действий не требуется.',
    translationJob: 'Задание перевода',
    issueKinds: {
      MISSING_TRANSLATION: 'Отсутствует переводов: {{count}}',
      UNREVIEWED_MACHINE_TRANSLATION: 'Непроверенных машинных переводов: {{count}}',
      INVALID_FORMULA: 'Недопустимая формула',
      UNUSED_DEFINITION: 'Не используется',
      ARCHIVE_CANDIDATE: 'Не используется не менее 180 дней',
      DEFINITION_CONFLICT: 'Конфликтов определений: {{count}}',
      FAILED_TRANSLATION_JOB: 'Не удалось переводов: {{count}}',
    },
    trackingId: 'ID отслеживания: {{trackingId}}',
    open: 'Открыть',
    generatedAt: 'Последняя проверка: {{date}}',
  },
  showArchived: 'Показывать архивные',
  showPreview: 'Показать предпросмотр',
  noGroups: 'Для этой области пока нет категории',
  noGroupsHint: 'Создайте категорию, затем назначьте ей поля.',
  dragGroup: 'Переместить категорию',
  dragField: 'Переместить поле',
  dropFieldHere: 'Перетащите поле сюда или создайте новое.',
  archivedStatus: 'В архиве',
  fieldCount: '{{count}} полей',
  valueCount: '{{count}} значений',
  masterDataPreview: 'Предпросмотр основных данных',
  masterDataPreviewHint: 'Отображение с выбранной шириной карточки и расположением полей.',
  usagePreviewContext: 'Контекст использования',
  usagePreviewLanguage: 'Язык предпросмотра',
  usagePreviewViewport: 'Вид',
  usagePreviewViewports: { DESKTOP: 'Компьютер', TABLET: 'Планшет', MOBILE: 'Телефон' },
  usagePreviewCanvas: 'Локализованный предпросмотр',
  usagePreviewSafeSample: 'Предпросмотр без бизнес-данных',
  usagePreviewMissingCategory: 'Категория отсутствует',
  usagePreviewNoWarnings: 'Для этого контекста предупреждений не найдено.',
  usagePreviewWarnings: 'Предупреждений: {{count}}',
  usagePreviewWarningDetails: {
    label: 'название',
    category: 'название категории',
    options: 'варианты',
  },
  usagePreviewWarning: {
    MISSING_TRANSLATION: 'На этом языке отсутствует видимый текст ({{detail}}).',
    LABEL_TOO_LONG: 'Название из {{detail}} символов может быть слишком длинным.',
    DUPLICATE_LABEL: 'Другое поле в этой области использует то же название.',
    INVALID_DEFAULT: 'Значение по умолчанию не соответствует типу поля или вариантам.',
    EMPTY_OPTION: 'Хотя бы один видимый вариант пуст или отсутствует.',
    VISIBILITY_CONFLICT: 'Правила области действия и отображения противоречат друг другу.',
    INVALID_FORMULA: 'Формулу невозможно вычислить.',
  },
  emptyGroup: 'В этой категории пока нет полей.',
  groupArchiveTitle: 'Архивировать категорию',
  archiveImpactDescription:
    'Поле «{{label}}» скрывается для нового ввода. {{valueCount}} значений остаются доступными.',
  groupArchiveDescription:
    'Категория «{{label}}» и её {{fieldCount}} полей скрываются для нового ввода.',
  archivePreservesHistory:
    'Исторические значения, снимки документов, экспорт и аудит не удаляются.',
  archiveImpact: 'Затронуто: {{fieldCount}} полей и {{valueCount}} сохранённых значений.',
} as const;

export const customFieldBuilderTr = {
  builderSubtitle: 'Kategorileri, kapsamları, çevirileri ve görünümü tek yerde yönetin.',
  area: 'İş alanı',
  createGroup: 'Yeni kategori',
  groupCreated: 'Kategori oluşturuldu.',
  groupUpdated: 'Kategori kaydedildi.',
  groupArchived: 'Kategori arşivlendi.',
  groupCreateTitle: 'Kategori oluştur',
  groupEditTitle: 'Kategoriyi düzenle',
  groupDialogDescription: 'Kategoriler alanları ana veri görünümünde gruplar.',
  name: 'Ad',
  icon: 'Simge anahtarı',
  color: 'Renk',
  scope: 'Geçerlilik alanları',
  partnerRoles: 'İş ortağı rolleri',
  partnerRolesHint: 'Seçim yapılmazsa tüm roller için geçerlidir.',
  roles: { CUSTOMER: 'Müşteri', PROSPECT: 'Potansiyel müşteri', SUPPLIER: 'Tedarikçi' },
  layoutWidth: 'Kart genişliği',
  widthFull: 'Tam genişlik',
  widthHalf: 'Yarım genişlik',
  fieldLayout: 'Alan düzeni',
  oneColumn: 'Tek sütun',
  twoColumns: 'İki sütun',
  active: 'Etkin',
  defaultExpanded: 'Varsayılan olarak açık',
  hideEmptyInDetail: 'Ayrıntıda boş değerleri gizle',
  readPermissions: 'Ek okuma izinleri',
  writePermissions: 'Ek yazma izinleri',
  permissionsHint: 'Seçim yapılmazsa ek kısıtlama yoktur.',
  helpText: 'Satır içi yardım',
  translationRequired: 'Bu çeviri eksik veya yalnızca boşluklardan oluşuyor.',
  translationDuplicate: 'Bu çeviri aynı dil içinde yineleniyor.',
  translationStatusComplete: 'Tam',
  translationStatusIncomplete: 'Eksik',
  translationValidationTitle: 'Ek alan henüz kaydedilemez.',
  groupTranslationValidationTitle: 'Ek alan kategorisi henüz kaydedilemez.',
  translationValidationCount: '{{count}} çeviri eksik veya çakışıyor:',
  translationFields: {
    label: 'Etiket',
    description: 'Açıklama',
    helpText: 'Yardım metni',
    name: 'Kategori etiketi',
  },
  translationFieldOption: 'Seçenek “{{value}}”',
  errorTrackingId: 'Takip kimliği: {{trackingId}}',
  saveDraft: 'Taslağı kaydet',
  checkAndActivate: 'Kontrol et ve etkinleştir',
  draftSaved: 'Taslak kaydedildi.',
  activated: 'Ek alan etkinleştirildi.',
  draftStatus: 'Taslak',
  pendingDraftStatus: 'Değişiklik taslağı',
  translationCompleteness: '{{total}} dilden {{complete}} tanesi tamamlandı',
  translationCompletenessHint: 'Eksik taslaklar kaydedilebilir ancak etkinleştirilemez.',
  autoTranslationTitle: 'Denetimli otomatik çeviri',
  autoTranslationPrivacy:
    'Yerel Ollama hizmetine yalnızca görünür tanım metinleri gönderilir. Sonuçlar siz uygulayana kadar kaydedilmez.',
  translationSourceLanguage: 'Kaynak dil',
  translateMissing: 'Eksik dilleri otomatik çevir',
  retranslateWarning:
    'Tüm hedef diller için yeni öneriler oluşturulsun mu? Mevcut metinler yalnızca açıkça uyguladığınızda değişir.',
  retranslateAll: 'Tümünü yeniden çevir',
  cancelTranslation: 'İptal',
  translationProgress: '{{total}} dilden {{completed}} tanesi işlendi',
  retryTranslation: 'Yeniden dene',
  translateLanguage: 'Çevir',
  translationReady: 'Öneri hazır',
  translationError: 'Başarısız',
  translationRunning: 'Çevriliyor',
  translationNotStarted: 'Başlatılmadı',
  translationSourceMissing: 'Kaynak dil ve görünür kaynak seçeneklerin tümü eksiksiz olmalıdır.',
  autoTranslationFailed: 'Yerel çeviri hizmeti bu dili oluşturamadı.',
  translationCancelled: 'Çeviri iptal edildi. Yeniden deneyebilirsiniz.',
  translationReviewOnApply: 'Öneriyi açıkça uygulamanız uzman incelemenizi doğrular.',
  translationReviewPermissionMissing:
    'Önerileri uygulayıp taslak kaydedebilirsiniz; yayımlama için çeviri inceleme yetkisi gerekir.',
  machineTranslation: 'Makine tarafından oluşturuldu',
  translationMemory: 'İncelenmiş çeviri belleğinden',
  translationReviewed: 'İncelendi',
  translationReviewRequired: 'İnceleme gerekli',
  translationReviewBlocksActivation:
    'Makine çevirileri etkinleştirmeden önce yetkili bir kullanıcı tarafından incelenmelidir.',
  translationComparisonTitle: '{{source}} → {{target}} karşılaştırması',
  translationComparisonHint: 'Uygulamadan önce kaynak, mevcut metin ve öneriyi karşılaştırın.',
  discardSuggestion: 'Öneriyi reddet',
  applyChange: 'Değişikliği uygula',
  sourceText: 'Kaynak metin',
  existingTranslation: 'Mevcut çeviri',
  suggestedTranslation: 'Önerilen çeviri',
  applyAllLanguageChanges: 'Bu dildeki tüm değişiklikleri uygula',
  unsavedWarning: 'Kaydedilmemiş değişiklikler silinsin mi?',
  confidentiality: 'Gizlilik',
  confidentialities: { PUBLIC: 'Genel', INTERNAL: 'Dahili', CONFIDENTIAL: 'Gizli' },
  confidential: 'Gizli',
  optionTranslationsHint: 'Her seçeneği tüm ERP dillerinde tanımlayın.',
  optionValue: 'Teknik değer',
  defaultAndValidation: 'Varsayılan ve doğrulama',
  defaultValue: 'Varsayılan değer',
  noDefault: 'Varsayılan yok',
  multiDefaultHint: 'Birden çok değeri virgülle ayırın.',
  minLength: 'En az uzunluk',
  maxLength: 'En fazla uzunluk',
  minimum: 'En az',
  maximum: 'En fazla',
  configurationLocked:
    'Bu alanı {{count}} değer kullanıyor. Anahtar, tür ve mevcut seçenek değerleri korunur.',
  impactAffectedRecords: 'Etkilenen kayıtlar',
  impactRisk: 'Değişiklik riski',
  impactContexts: 'Varlıklar ve roller',
  impactUsageTitle: 'Yayımlanmış tanımın kullanımı',
  impactNoUsage: 'Güncel kullanım bulunamadı.',
  impactUsages: {
    FORMS: 'Formlar',
    LISTS: 'Listeler',
    FILTERS: 'Filtreler',
    FORMULAS: 'Formüller',
    PDF_TEMPLATES: 'PDF şablonları',
    SPECIFICATIONS: 'Spesifikasyonlar',
    IMPORT_PROFILES: 'İçe aktarma profilleri',
    DOCUMENTS: 'Belgeler ve kalemler',
    AUTOMATIONS: 'Otomasyonlar ve segmentler',
  },
  impactChangesTitle: 'Denetlenen değişiklikler',
  impactChanges: {
    KEY: 'Teknik anahtar',
    FIELD_TYPE: 'Alan türü',
    OPTIONS: 'Seçenek değerleri veya sırası',
    FORMULA: 'Formül',
    SCOPE: 'Kapsam',
    REQUIRED: 'Zorunlu alan kuralı',
    DEFAULT: 'Varsayılan değer',
    VISIBILITY: 'Görüntüleme ve görünürlük kuralları',
    TRANSLATIONS: 'Çeviriler',
  },
  impactRisks: { LOW: 'Düşük', MEDIUM: 'Orta', HIGH: 'Yüksek' },
  impactMigrationTitle: 'Kontrollü geçiş gerekli',
  impactMigrationHint:
    'Yayımlanmış tanım korunur. Geçmiş değerlerin okunabilmesi için değişikliği bir yedek alan üzerinden gerçekleştirin.',
  impactMigrationSteps: {
    CREATE_REPLACEMENT: 'İstenen yapılandırmayla bir yedek alan oluşturun',
    MAP_VALUES: 'Eski değerleri açıkça yedek alanla eşleştirin',
    VERIFY_VALUES: 'Sonucu ve bağımlı yapılandırmaları doğrulayın',
    PUBLISH_REPLACEMENT: 'İncelenen yedek alanı yayımlayın',
    ARCHIVE_ORIGINAL: 'Önceki alanı arşivleyin',
  },
  impactConfirmTitle: 'Değişikliği inceleyin ve yayımlayın',
  impactConfirmDescription:
    'Değişiklik taslağını yayımlamadan önce kayıtları, kullanımları ve riski inceleyin.',
  impactPublish: 'İncelenen değişikliği yayımla',
  impactAnalysisFailed: 'Değişiklik etkisi denetlenemedi. Hiçbir şey yayımlanmadı.',
  impactAnalysisFailedWithTrackingId:
    'Değişiklik etkisi denetlenemedi. Hiçbir şey yayımlanmadı. Takip kimliği: {{trackingId}}',
  impactOptionLocked:
    'Bu seçenek için saklanmış değerler var. Değiştirmek için gösterilen geçiş yolunu kullanın.',
  publicationReason: 'Yayımlama gerekçesi',
  publicationReasonHint: 'Gerekçe, kullanıcı ve zaman denetim kaydında saklanır.',
  defaultPublicationReason: 'İncelenen değişiklik özel alan düzenleyicisinden yayımlandı.',
  versionHistoryTitle: 'Sürümler ve yayımlama',
  versionHistoryHint:
    'Önceki durumlar görünür kalır; geri dönüş her zaman yeni bir taslak oluşturur.',
  revision: 'Revizyon {{revision}}',
  versionStatuses: {
    DRAFT: 'Taslak',
    IN_REVIEW: 'İncelemede',
    PUBLISHED: 'Yayımlandı',
    SUPERSEDED: 'Önceki sürüm',
  },
  versionReasonMissing: 'Ayrı bir gerekçe kaydedilmedi.',
  versionComparisonTitle: 'Yayımlanmış sürümle karşılaştırma',
  versionPublishedValue: 'Yayımlanan',
  versionSelectedValue: 'Seçilen',
  versionIsPublished: 'Bu, şu anda yayımlanmış sürümdür.',
  versionNoPublished: 'Bu arşivlenmiş veya yeni alanın şu anda etkin bir yayımlanmış sürümü yok.',
  versionNoChanges: 'Yayımlanmış sürümden işlevsel bir fark yok.',
  versionFields: {
    translations: 'Çeviriler',
    fieldType: 'Alan türü',
    options: 'Seçenekler',
    formulaExpression: 'Formül',
    entityTypes: 'Varlıklar',
    partnerRoles: 'İş ortağı rolleri',
    isRequired: 'Zorunlu alan',
    defaultValue: 'Varsayılan değer',
    showInList: 'Liste görünümü',
    isFilterable: 'Filtre',
    showInPdf: 'PDF görünümü',
  },
  versionReason: 'Gerekçe',
  versionReasonHint: 'En az üç karakter; denetim kaydında saklanır.',
  submitForReview: 'İncelemeye gönder',
  rollbackAsDraft: 'Yeni taslak olarak geri yükle',
  inReviewStatus: 'İncelemede',
  pendingReviewStatus: 'Değişiklik incelemede',
  publishingSettingsTitle: 'Güvenli yayımlama',
  publishingSettingsHint: 'Bu kiracı için özel alan yayımlamasını yönetin.',
  fourEyesEnabled: 'Dört göz ilkesini etkinleştir',
  fourEyesDescription: 'Revizyonu gönderen kullanıcı aynı revizyonu yayımlayamaz.',
  publishingSettingsSaved: 'Yayımlama ayarı kaydedildi.',
  transfer: {
    title: 'Dışa aktarma, içe aktarma ve toplu bakım',
    description:
      'Tanımları ve çevirileri dışa aktarın, CSV/XLSX dosyasını tamamen doğrulayın ve yalnızca taslak olarak içe aktarın.',
    exportXlsx: 'XLSX dışa aktar',
    exportCsv: 'CSV dışa aktar',
    selectFile: 'İçe aktarma dosyası seç',
    uploading: 'Dosya doğrulanıyor …',
    previewHint: 'İçe aktarma ancak sunucu önizlemesi ve onayınızdan sonra çalışır.',
    previewTitle: 'İçe aktarma önizlemesi',
    resultTitle: 'İçe aktarma sonucu',
    errorReport: 'Hata raporunu indir',
    counts: {
      total: 'Toplam',
      new: 'Yeni',
      changed: 'Değişti',
      unchanged: 'Değişmedi',
      invalid: 'Hatalı',
    },
    errorSummary: '{{count}} içe aktarma hatası düzeltilmelidir.',
    errorLine: 'Satır {{row}}, sütun {{column}}: {{message}}',
    row: 'Satır',
    key: 'Alan anahtarı',
    area: 'Alan',
    label: 'Etiket',
    status: 'Sonuç',
    statuses: { NEW: 'Yeni', CHANGED: 'Değişti', UNCHANGED: 'Değişmedi', INVALID: 'Hatalı' },
    confirmDraftImport:
      'Önizlemeyi inceledim ve yeni ya da değişen tanımları taslak olarak içe aktarıyorum.',
    generateMissing: 'Eksik çevirileri içe aktarmadan sonra kontrollü arka plan işiyle oluştur',
    sourceLocale: 'Kaynak dil',
    draftOnly: 'İçe aktarma hiçbir tanımı etkinleştirmez veya yayımlanmış sürümü değiştirmez.',
    importing: 'İçe aktarılıyor …',
    execute: 'İncelenen içe aktarmayı çalıştır',
    completed:
      '{{created}} yeni ve {{changed}} değişen taslak içe aktarıldı; {{invalid}} satır başarısız.',
    translationJob: 'Çeviri işi',
    translationProgress: 'Otomatik çeviri ilerlemesi',
    translationCounts: '{{total}} öğeden {{done}} işlendi, {{failed}} başarısız',
    retry: 'İşi sürdür',
  },
  quality: {
    title: 'Yapılandırma kalitesi',
    description: 'Bekleyen çeviri, formül, kullanım ve iş sorunlarını bulun ve doğrudan açın.',
    refresh: 'Yeniden denetle',
    category: 'Kategori',
    language: 'Dil',
    status: 'Durum',
    metrics: {
      activeDefinitions: 'Etkin özel alanlar',
      incompleteDrafts: 'Eksik taslaklar',
      missingTranslations: 'Eksik çeviriler',
      unreviewedMachineTranslations: 'İncelenmemiş makine çevirileri',
      invalidFormulas: 'Geçersiz formüller',
      unusedDefinitions: 'Kullanılmayan alanlar',
      archiveCandidates: 'Arşiv adayları',
      definitionConflicts: 'Tanım çakışmaları',
      failedTranslationJobs: 'Başarısız çeviri işleri',
    },
    byLanguage: 'Dile göre tamlık',
    languageProgress: '{{language}} için çeviri ilerlemesi',
    languageSummary: '{{total}} alandan {{complete}} tanesi tam · {{missing}} metin eksik',
    issues: 'İşlem gerekiyor',
    noIssues: 'Seçili filtreler için işlem gerekmiyor.',
    translationJob: 'Çeviri işi',
    issueKinds: {
      MISSING_TRANSLATION: '{{count}} çeviri eksik',
      UNREVIEWED_MACHINE_TRANSLATION: '{{count}} makine çevirisi incelenmemiş',
      INVALID_FORMULA: 'Geçersiz formül',
      UNUSED_DEFINITION: 'Kullanılmıyor',
      ARCHIVE_CANDIDATE: 'En az 180 gündür kullanılmıyor',
      DEFINITION_CONFLICT: '{{count}} tanım çakışması',
      FAILED_TRANSLATION_JOB: '{{count}} çeviri başarısız',
    },
    trackingId: 'Takip kimliği: {{trackingId}}',
    open: 'Aç',
    generatedAt: 'Son denetim: {{date}}',
  },
  showArchived: 'Arşivlenenleri göster',
  showPreview: 'Önizlemeyi göster',
  noGroups: 'Bu alan için henüz kategori yok',
  noGroupsHint: 'Önce bir kategori oluşturun, ardından alanları atayın.',
  dragGroup: 'Kategoriyi taşı',
  dragField: 'Alanı taşı',
  dropFieldHere: 'Bir alanı buraya sürükleyin veya yeni alan oluşturun.',
  archivedStatus: 'Arşivlendi',
  fieldCount: '{{count}} alan',
  valueCount: '{{count}} değer',
  masterDataPreview: 'Ana veri önizlemesi',
  masterDataPreviewHint: 'Seçilen kart genişliği ve alan düzeniyle görünüm.',
  usagePreviewContext: 'Kullanım bağlamı',
  usagePreviewLanguage: 'Önizleme dili',
  usagePreviewViewport: 'Görünüm',
  usagePreviewViewports: { DESKTOP: 'Masaüstü', TABLET: 'Tablet', MOBILE: 'Mobil' },
  usagePreviewCanvas: 'Yerelleştirilmiş kullanım önizlemesi',
  usagePreviewSafeSample: 'İş verisi içermeyen önizleme',
  usagePreviewMissingCategory: 'Kategori eksik',
  usagePreviewNoWarnings: 'Bu bağlam için önizleme uyarısı bulunamadı.',
  usagePreviewWarnings: '{{count}} önizleme uyarısı',
  usagePreviewWarningDetails: { label: 'etiket', category: 'kategori adı', options: 'seçenekler' },
  usagePreviewWarning: {
    MISSING_TRANSLATION: 'Bu dilde görünür bir metin eksik ({{detail}}).',
    LABEL_TOO_LONG: '{{detail}} karakterlik etiket çok uzun olabilir.',
    DUPLICATE_LABEL: 'Bu alandaki başka bir alan aynı etiketi kullanıyor.',
    INVALID_DEFAULT: 'Varsayılan değer alan türüyle veya seçeneklerle eşleşmiyor.',
    EMPTY_OPTION: 'En az bir görünür seçenek boş veya eksik.',
    VISIBILITY_CONFLICT: 'Kapsam ve görünüm kuralları birbiriyle çelişiyor.',
    INVALID_FORMULA: 'Formül değerlendirilemiyor.',
  },
  emptyGroup: 'Bu kategoride henüz alan yok.',
  groupArchiveTitle: 'Kategoriyi arşivle',
  archiveImpactDescription:
    '“{{label}}” alanı yeni girişlerden gizlenir. {{valueCount}} kayıtlı değer okunabilir kalır.',
  groupArchiveDescription:
    '“{{label}}” kategorisi ve {{fieldCount}} alanı yeni girişlerden gizlenir.',
  archivePreservesHistory:
    'Geçmiş değerler, belge anlık görüntüleri, dışa aktarımlar ve denetim kayıtları silinmez.',
  archiveImpact: 'Etkilenen: {{fieldCount}} alan ve {{valueCount}} kayıtlı değer.',
} as const;
